//@ts-nocheck
/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 6
 */

export interface AcknowledgeAlert {
  alertCode: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  alertId: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationId: number;
  /**
   *
   * - Format: date-time
   */
  until?: string;
}

export interface ActiveBioscope {
  bioscopeStatus: string;
  bioscopeVersion: string;
  client: { id?: number; name?: string };
  clientId: number;
  connection: {
    cabinet?: number;
    id?: number;
    /**
     *
     * - Format: date-time
     */
    lastSeen?: string;
  };
  id: number;
  jetpackVersion: string;
  /**
   *
   * - Format: date-time
   */
  lastAlive: string;
  lastLocation: BioscopeLastLocation;
  lastMeasurement: {
    /**
     *
     * - Format: date-time
     */
    timestamp?: string;
  };
  uvc: boolean;
  version: { id?: number; version?: string };
  winchExists: boolean;
  winchId: number;
  configuration?: BioscopeConfiguration;
  isTestBioscope?: boolean;
}

export interface ActivityLogController_getActivityLogQueryParams {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  from?: string;
  limit?: number;
  page?: number;
  to?: string;
}

export interface ActivityLogEntryDto {
  action: string;
  createdAt: string;
  id: number;
  locationId: number;
  /**
 * 
 * Denormalized snapshot of the source task's `alert_code` for alert-derived
events. Used by the frontend to render translated titles/descriptions
even after the source task is gone.
 */
  alertCode?: string;
  bioscopeId?: number;
  cageId?: number;
  cageName?: string;
  comment?: string;
  /**
 * 
 * Free-form description (e.g. operator comment); null for system-generated
events. When null and `descriptionKey` is set, the frontend renders the
description via i18next using `descriptionKey` + `templateVariables`.
 */
  description?: string;
  /**
 * 
 * i18n key for system-generated descriptions (e.g. `taskAutoResolved.alertCleared`).
Null for events whose description is purely operator-entered text.
 */
  descriptionKey?: string;
  performedBy?: number;
  performedByName?: string;
  taskId?: number;
  /**
 * 
 * JSON snapshot of variables (penName, lastMeasurement, etc.) needed to
render the title/description on the frontend. Captured at log time so
the entry stays accurate even after cage/bioscope context changes.
 */
  templateVariables?: { [x in string | number]: any };
  /**
 * 
 * Free-form title for manual events; null for alert-derived events. When
null, the frontend renders the title from `alertCode` + `templateVariables`.
 */
  title?: string;
}

export interface ActivityLogResponseDto {
  entries: ActivityLogEntryDto[];
  locationId: number;
  pagination: {
    hasMore?: boolean;
    limit?: number;
    page?: number;
    total?: number;
  };
}

export interface Alert {
  alertCode: string;
  bioscopeId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  solvedAt: string;
}

export interface AlertAcknowledgement {
  acknowledged: boolean;
  alertCode: string;
  id: number;
  locationId: number;
  alertId?: number;
}

export interface AllWeeklyReportResponseDto {
  reports: AllWeeklyReportResult[];
  /**
   *
   * Which implementation actually answered, after the server applied its own rules — not necessarily what was requested.
   */
  source: "sql" | "core" | "compare";
  /**
   *
   * Only for `source=compare`. **Covers the running week alone**: every other week in `reports` is read from `lice_report` and is not recomputed, so there is nothing to compare it against. Absent when the running week is already stored, because then nothing was computed live either.
   */
  parity?: LiceParityDto;
}

export interface AllWeeklyReportResult {
  /**
   *
   * True for the running week, which is computed on the fly rather than read from a stored report.
   */
  interimReport: boolean;
  /**
   *
   * ISO week the report covers.
   * @example
   *   22
   */
  isoWeek: number;
  /**
   *
   * ISO week year the report covers.
   * @example
   *   2026
   */
  isoYear: number;
  /**
   *
   * Locations the requesting user may see, with their cages.
   */
  locations: LiceReportLocations[];
}

export interface AssignFishGroupsToCycleRequest {
  /**
   *
   * Groups to add. Each group's whole lineage component (everything it is connected to by transfers) moves with it, so a cycle never splits a lineage.
   */
  fishGroupIds: number[];
  /**
   *
   * Why the groups are being assigned. Persisted as the notes of each event.
   */
  reason: string;
}

export interface AssignFishGroupsToCycleResponseDto {
  /**
   *
   * Groups whose cycle changes (or would, on a dry run). Each gets a metadata_updated event.
   */
  assigned: AssignedFishGroupDto[];
  dryRun: boolean;
  stockingCycleId: number;
  /**
   *
   * Groups in the cascade that were already in this cycle.
   */
  unchangedFishGroupIds: number[];
  /**
   *
   * Advisory only; never blocks.
   */
  warnings: StockingCycleWarningDto[];
}

export interface AssignedFishGroupDto {
  fishGroupId: number;
  name: string;
  /**
   *
   * True when the caller named this group; false when it moved because it shares lineage with one.
   */
  requested: boolean;
  status: string;
  previousStockingCycleId?: number;
}

export enum AuditLogActorType {
  user = "user",
  api_user = "api_user",
  production_key = "production_key",
  anonymous = "anonymous",
}

export interface AuditLogController_exportQueryParams {
  /**
   *
   * Action prefix: "user." matches every user action
   * - maxLength: 100
   */
  action?: string;
  /**
   *
   * Exact actions; repeatable
   * - maxLength: 100
   */
  actions?: string[];
  /**
   *
   * Case-insensitive part of the actor or impersonator email
   * - maxLength: 255
   */
  actorEmail?: string;
  /**
   *
   * Repeatable
   */
  actorType?: AuditLogActorType[];
  /**
   *
   * users.id for a user, apiUsers.id for an API user; add actorType to tell them apart
   * - minimum: 1
   * - max: 2147483647
   */
  actorUserId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  /**
   *
   * A key present in the before or after state of the changes
   * - pattern: ^[A-Za-z_][A-Za-z0-9_]{0,63}$
   */
  changedField?: string;
  /**
   *
   * The before value of changedField; numbers and booleans also match as such
   * - maxLength: 1000
   */
  changedFrom?: string;
  /**
   *
   * The after value of changedField; numbers and booleans also match as such
   * - maxLength: 1000
   */
  changedTo?: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId?: number;
  /**
   *
   * - maxLength: 255
   */
  entityId?: string;
  /**
   *
   * Case-insensitive part of the label written with the entry
   * - maxLength: 255
   */
  entityLabel?: string;
  /**
   *
   * Repeatable
   * - maxLength: 50
   */
  entityType?: string[];
  /**
   *
   * Exact entry id
   * - pattern: ^\d{1,19}$
   */
  entryId?: string;
  /**
   *
   * Exact actions to leave out; repeatable
   * - maxLength: 100
   */
  excludeActions?: string[];
  /**
   *
   * Inclusive lower bound, ISO 8601 ending in Z or an offset
   * - pattern: (Z|[+-]\d{2}:\d{2})$
   */
  from?: string;
  impersonation?: "only" | "exclude";
  /**
   *
   * Case-insensitive part of the impersonator email
   * - maxLength: 255
   */
  impersonatorEmail?: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  impersonatorUserId?: number;
  /**
   *
   * Exact IPv4 or IPv6 address
   */
  ip?: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationId?: number;
  /**
   *
   * Dotted path into the request data, such as body.name; alone, the path exists
   * - pattern: ^[A-Za-z0-9_-]{1,64}(\.[A-Za-z0-9_-]{1,64}){0,4}$
   */
  metadataPath?: string;
  /**
   *
   * The value at metadataPath, or an element of the array there; numbers and booleans also match as such
   * - maxLength: 1000
   */
  metadataValue?: string;
  /**
   *
   * Repeatable
   */
  method?: AuditLogMethod[];
  /**
   *
   * Repeatable
   */
  outcome?: AuditLogOutcome[];
  /**
   *
   * Exact request id; every entry of one request
   * - maxLength: 255
   */
  requestId?: string;
  /**
   *
   * Route template prefix, such as /api/v2/cage
   * - maxLength: 255
   */
  route?: string;
  /**
   *
   * Only denied and failed entries carry a status code
   * - minimum: 100
   * - max: 599
   */
  statusCode?: number;
  /**
   *
   * Exclusive upper bound, ISO 8601 ending in Z or an offset
   * - pattern: (Z|[+-]\d{2}:\d{2})$
   */
  to?: string;
  /**
   *
   * Case-insensitive part of the user agent
   * - maxLength: 500
   */
  userAgent?: string;
}

export interface AuditLogController_listQueryParams {
  /**
   *
   * Action prefix: "user." matches every user action
   * - maxLength: 100
   */
  action?: string;
  /**
   *
   * Exact actions; repeatable
   * - maxLength: 100
   */
  actions?: string[];
  /**
   *
   * Case-insensitive part of the actor or impersonator email
   * - maxLength: 255
   */
  actorEmail?: string;
  /**
   *
   * Repeatable
   */
  actorType?: AuditLogActorType[];
  /**
   *
   * users.id for a user, apiUsers.id for an API user; add actorType to tell them apart
   * - minimum: 1
   * - max: 2147483647
   */
  actorUserId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  /**
   *
   * A key present in the before or after state of the changes
   * - pattern: ^[A-Za-z_][A-Za-z0-9_]{0,63}$
   */
  changedField?: string;
  /**
   *
   * The before value of changedField; numbers and booleans also match as such
   * - maxLength: 1000
   */
  changedFrom?: string;
  /**
   *
   * The after value of changedField; numbers and booleans also match as such
   * - maxLength: 1000
   */
  changedTo?: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId?: number;
  /**
   *
   * nextCursor from the previous page
   * - pattern: ^\d{1,19}$
   */
  cursor?: string;
  /**
   *
   * - maxLength: 255
   */
  entityId?: string;
  /**
   *
   * Case-insensitive part of the label written with the entry
   * - maxLength: 255
   */
  entityLabel?: string;
  /**
   *
   * Repeatable
   * - maxLength: 50
   */
  entityType?: string[];
  /**
   *
   * Exact entry id
   * - pattern: ^\d{1,19}$
   */
  entryId?: string;
  /**
   *
   * Exact actions to leave out; repeatable
   * - maxLength: 100
   */
  excludeActions?: string[];
  /**
   *
   * Inclusive lower bound, ISO 8601 ending in Z or an offset
   * - pattern: (Z|[+-]\d{2}:\d{2})$
   */
  from?: string;
  impersonation?: "only" | "exclude";
  /**
   *
   * Case-insensitive part of the impersonator email
   * - maxLength: 255
   */
  impersonatorEmail?: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  impersonatorUserId?: number;
  /**
   *
   * Exact IPv4 or IPv6 address
   */
  ip?: string;
  /**
   *
   * - minimum: 1
   * - max: 200
   */
  limit?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationId?: number;
  /**
   *
   * Dotted path into the request data, such as body.name; alone, the path exists
   * - pattern: ^[A-Za-z0-9_-]{1,64}(\.[A-Za-z0-9_-]{1,64}){0,4}$
   */
  metadataPath?: string;
  /**
   *
   * The value at metadataPath, or an element of the array there; numbers and booleans also match as such
   * - maxLength: 1000
   */
  metadataValue?: string;
  /**
   *
   * Repeatable
   */
  method?: AuditLogMethod[];
  /**
   *
   * Repeatable
   */
  outcome?: AuditLogOutcome[];
  /**
   *
   * Exact request id; every entry of one request
   * - maxLength: 255
   */
  requestId?: string;
  /**
   *
   * Route template prefix, such as /api/v2/cage
   * - maxLength: 255
   */
  route?: string;
  /**
   *
   * Only denied and failed entries carry a status code
   * - minimum: 100
   * - max: 599
   */
  statusCode?: number;
  /**
   *
   * Exclusive upper bound, ISO 8601 ending in Z or an offset
   * - pattern: (Z|[+-]\d{2}:\d{2})$
   */
  to?: string;
  /**
   *
   * Case-insensitive part of the user agent
   * - maxLength: 500
   */
  userAgent?: string;
}

export interface AuditLogEntryDto {
  action: string;
  actorType: "user" | "api_user" | "production_key" | "anonymous";
  entityType: string;
  /**
   *
   * bigint, as a decimal string
   */
  id: string;
  /**
   *
   * ISO 8601, UTC
   */
  occurredAt: string;
  outcome: "success" | "denied" | "failed";
  actorEmail?: string;
  actorUserId?: number;
  cageId?: number;
  changes?: { [x: string]: any };
  clientId?: number;
  /**
   *
   * Current name of cageId
   */
  currentCageName?: string;
  /**
   *
   * Null exactly when cageId is null
   */
  currentCageState?:
    "active" | "archived" | "deleted" | "historical" | "missing";
  /**
   *
   * Current name of clientId
   */
  currentClientName?: string;
  /**
   *
   * Null exactly when clientId is null
   */
  currentClientState?:
    "active" | "archived" | "deleted" | "historical" | "missing";
  /**
   *
   * Current name of locationId
   */
  currentLocationName?: string;
  /**
   *
   * Null exactly when locationId is null
   */
  currentLocationState?:
    "active" | "archived" | "deleted" | "historical" | "missing";
  entityId?: string;
  entityLabel?: string;
  impersonatorEmail?: string;
  impersonatorUserId?: number;
  ip?: string;
  locationId?: number;
  metadata?: { [x: string]: any };
  method?: string;
  requestId?: string;
  route?: string;
  statusCode?: number;
  userAgent?: string;
}

export interface AuditLogFacetsDto {
  /**
   *
   * Every action recorded so far, sorted
   */
  actions: string[];
  /**
   *
   * Every entity type recorded so far, sorted
   */
  entityTypes: string[];
}

export enum AuditLogMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export interface AuditLogOptionsController_scopesQueryParams {
  /**
   *
   * Case-insensitive part of a client, site or pen name
   * - maxLength: 100
   * - minLength: 2
   */
  q: string;
}

export enum AuditLogOutcome {
  success = "success",
  denied = "denied",
  failed = "failed",
}

export interface AuditLogPageDto {
  entries: AuditLogEntryDto[];
  /**
   *
   * Pass as `cursor` for the next page; null on the last page
   */
  nextCursor?: string;
}

export interface AuditScopeOptionDto {
  id: number;
  kind: "client" | "location" | "cage";
  state: "active" | "archived" | "deleted" | "historical" | "missing";
  /**
   *
   * The owning client of a site or pen
   */
  clientName?: string;
  /**
   *
   * The site of a pen
   */
  locationName?: string;
  name?: string;
}

export interface BehaviorAveragesDto {
  /**
   *
   * Average active respiration over the last 3 days in %
   * @example
   *   35
   */
  activeRespiration?: number;
  /**
   *
   * Number of respiration measurements (null if not available)
   * @example
   *   100
   */
  numberOfRespirationMeasurements?: number;
  /**
   *
   * Number of swim speed measurements (null if not available)
   * @example
   *   100
   */
  numberOfSwimSpeedMeasurements?: number;
  /**
   *
   * Number of tilt measurements (null if not available)
   * @example
   *   100
   */
  numberOfTiltMeasurements?: number;
  /**
   *
   * Average swim speed over the last 3 days in KL/s
   * @example
   *   1.25
   */
  swimSpeed?: number;
  /**
   *
   * Average tilt over the last 3 days in degrees
   * @example
   *   15.5
   */
  tilt?: number;
}

export interface BehaviorController_getOverviewQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface BehaviorController_getRespirationQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Start date (YYYY-MM-DD). Defaults to 30 days ago if not provided.
   */
  from?: string;
  /**
   *
   * Request hourly data instead of daily data
   */
  showHourly?: boolean;
  /**
   *
   * End date (YYYY-MM-DD). Defaults to today if not provided.
   */
  to?: string;
}

export interface BehaviorController_getSwimSpeedQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Start date (YYYY-MM-DD). Defaults to 30 days ago if not provided.
   */
  from?: string;
  /**
   *
   * Request hourly data instead of daily data
   */
  showHourly?: boolean;
  /**
   *
   * End date (YYYY-MM-DD). Defaults to today if not provided.
   */
  to?: string;
}

export interface BehaviorController_getTiltQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Start date (YYYY-MM-DD). Defaults to 30 days ago if not provided.
   */
  from?: string;
  /**
   *
   * Request hourly data instead of daily data
   */
  showHourly?: boolean;
  /**
   *
   * End date (YYYY-MM-DD). Defaults to today if not provided.
   */
  to?: string;
}

export interface BehaviourBlockDto {
  /**
   *
   * Empty when the cage has neither the FISH_SPEED nor the BEHAVIOR licence covering the range.
   */
  days: BehaviourDayDto[];
}

export interface BehaviourDayDto {
  data: BehaviourDayMetricsDto;
  /**
   *
   * YYYY-MM-DD.
   * @example
   *   2026-07-27
   */
  day: string;
  /**
   *
   * Daypart this row aggregates.
   * @example
   *   day
   */
  daypartTag: string;
}

export interface BehaviourDayMetricsDto {
  /**
   *
   * Mean three-dimensional swim speed, in body lengths per second.
   */
  fishSpeed3dAvg?: number;
  /**
   *
   * Mean swim speed, in body lengths per second.
   */
  fishSpeedAvg?: number;
  /**
   *
   * Mean vertical swim speed component, in body lengths per second.
   */
  fishSpeedYAvg?: number;
}

export interface BiomassBlockDto {
  /**
   *
   * Empty when the cage has no BIOMASS.FULL licence covering the range.
   */
  days: BiomassDayDto[];
  estimate: BiomassEstimateDto;
  period: BiomassPeriodDto;
}

export interface BiomassController_GetFeedingConversionRateQueryParams {
  /**
   *
   * - Format: date-time
   */
  from: string;
  /**
   *
   * - Format: date-time
   */
  to: string;
  weight_unit_tag: string;
}

export interface BiomassDayDto {
  data: BiomassDayMetricsDto;
  /**
   *
   * YYYY-MM-DD.
   * @example
   *   2026-07-27
   */
  day: string;
  /**
   *
   * Daypart this row aggregates.
   * @example
   *   day
   */
  daypartTag: string;
}

export interface BiomassDayMetricsDto {
  /**
   *
   * Mean condition factor.
   */
  cfAvg?: number;
  /**
   *
   * Never filled — always null. Kept so the response shape stays stable.
   */
  cfTrend?: number;
  /**
   *
   * Coefficient of variation of weight, as a percentage.
   */
  cv?: number;
  /**
   *
   * Mean fish height, in millimetres.
   */
  fishHeightAvg?: number;
  /**
   *
   * Mean fish length, in millimetres.
   */
  fishLengthAvg?: number;
  /**
   *
   * Fish measured on this day and daypart.
   */
  measCnt?: number;
  /**
   *
   * Mean living weight.
   */
  weightAvg?: number;
  /**
   *
   * Confidence interval width around `weightAvg`.
   */
  weightConf?: number;
  /**
   *
   * Upper confidence bound for `weightTrend`. Null while the trend is null.
   */
  weightConfHi?: number;
  /**
   *
   * Lower confidence bound for `weightTrend`. Null while the trend is null.
   */
  weightConfLo?: number;
  /**
   *
   * Mean daily growth.
   */
  weightGrowthAvg?: number;
  /**
   *
   * Never filled — always null. Kept so the response shape stays stable.
   */
  weightGrowthTrend?: number;
  /**
   *
   * Modelled weight trend. Null until the trend window has filled.
   */
  weightTrend?: number;
}

export interface BiomassEstimateDto {
  /**
   *
   * Most recent day with a measurement. Empty when the cage has never measured.
   * @example
   *   2026-07-27
   */
  lastDay: string;
  /**
   *
   * Machine-readable reasons the estimate is degraded. Some are admin-only and are filtered client-side.
   */
  measStatusList: string[];
  /**
   *
   * Living weight on `lastDay`, in the requested weight unit.
   */
  estimatedWeight?: number;
  /**
   *
   * 0 is healthy; higher values mean the estimate is degraded.
   */
  measStatusLevel?: number;
}

export interface BiomassOverviewDaySceneLabelDto {
  /**
   *
   * Frames carrying this tag.
   */
  count: number;
  /**
   *
   * Share of the day's frames, 0 to 1.
   */
  relativeCount: number;
  /**
   *
   * Raw bioscope tag, ungrouped — unlike the top-level scene labels.
   * @example
   *   school
   */
  tag: string;
}

export interface BiomassOverviewFilterDto {
  /**
   *
   * Start of the range the data actually covers. Not necessarily what was requested: an omitted `from` opens a 28-day window ending on the last measured day.
   * @example
   *   2026-06-27
   */
  dayFrom: string;
  /**
   *
   * End of the resolved range.
   * @example
   *   2026-07-27
   */
  dayTo: string;
  /**
   *
   * Daypart the period aggregates and the scene labels were computed for.
   * @example
   *   day
   */
  daypartTag: string;
  /**
   *
   * Unit the weights are expressed in. Always `g`.
   * @example
   *   g
   */
  weightUnitTag: string;
}

export interface BiomassOverviewResponseDto {
  behaviour: BehaviourBlockDto;
  /**
   *
   * Weight estimates and their aggregates. Note that `estimate` and `period` are NOT licence-filtered while `days` is, so an unlicensed cage still receives a living-weight figure alongside an empty series. That asymmetry predates this DTO and is a product decision, tracked separately.
   */
  biomass: BiomassBlockDto;
  /**
   *
   * Camera telemetry and image diagnostics. A property of the equipment in the cage rather than of the fish.
   */
  bioscope: BioscopeBlockDto;
  filter: BiomassOverviewFilterDto;
  /**
   *
   * Latest hourly environmental snapshot. Null when the cage has no hourly environmental sensor data.
   */
  environmental?: EnvironmentalBlockDto;
}

export interface BiomassOverviewSceneLabelDto {
  /**
   *
   * Frames in this category.
   */
  count: number;
  /**
   *
   * Window the totals cover.
   * @example
   *   2d
   */
  dataRangeTag: string;
  /**
   *
   * Daypart the totals were computed for.
   * @example
   *   day
   */
  daypartTag: string;
  /**
   *
   * Share of frames, 0 to 1.
   */
  relativeCount: number;
  /**
   *
   * One of the seven categories. camelCase, and a live contract: the frontend indexes chart colours and translation keys by this value.
   * @example
   *   farAway
   */
  sceneLabelTag: string;
}

export interface BiomassPeriodDto {
  /**
   *
   * Condition factor.
   */
  cf?: number;
  /**
   *
   * Change in condition factor over the range.
   */
  cfGrowth?: number;
  /**
   *
   * Coefficient of variation of weight, as a percentage.
   */
  cv?: number;
  /**
   *
   * Condition factor a fish of this weight is expected to have.
   */
  expectedCf?: number;
  /**
   *
   * Number of fish measurements across the whole range.
   */
  measCnt?: number;
  /**
   *
   * Relative growth index: measured SGR over modelled SGR.
   */
  rgi?: number;
  /**
   *
   * Specific growth rate: growth relative to mean weight.
   */
  sgr?: number;
  /**
   *
   * Mean living weight over the range.
   */
  weight?: number;
  /**
   *
   * Mean daily growth over the range, in weight unit per day.
   */
  weightGrowth?: number;
}

export interface BioscopeBlockDto {
  days: BioscopeDayDto[];
  sceneLabels: BiomassOverviewSceneLabelDto[];
}

export interface BioscopeCage {
  id: number;
  location: {
    geom?: { latitude?: number; longitude?: number };
    id?: number;
    name?: string;
  };
  name: string;
  /**
 * 
 * The fish group in this pen now. Only the internal `GET bioscope/active` list
resolves it: absent means not requested, `null` means an empty pen. The
client-scoped list leaves it out, since group visibility for customers follows
its own rule.
 */
  activeFishGroup?: OverviewFishGroupSummaryDto;
  cageType?: string;
  /**
 * 
 * Species in THIS pen (WB-2207). It used to sit under `location`, which became
misleading once a location could hold several species: the value was the pen's while
the key said location. Null when neither the pen nor its location records one.
 */
  fishTypes?: FishType;
}

export interface BioscopeConfiguration {
  bioscopeId: number;
  id: number;
  config?: BioscopeConfigurationJson;
}

export interface BioscopeConfigurationJson {
  LUX?: number;
  bioScopeID?: number;
  bioscopeVersion?: string;
  classifyAdiposeFin?: boolean;
  debugFlag?: boolean;
  keepFullSequenceInterval?: number;
  saveColorFishHeadPickle?: boolean;
  swapWithRealData?: boolean;
}

export interface BioscopeDayDto {
  data: BioscopeDayMetricsDto;
  /**
   *
   * YYYY-MM-DD.
   * @example
   *   2026-07-27
   */
  day: string;
  /**
   *
   * Daypart this row aggregates.
   * @example
   *   day
   */
  daypartTag: string;
  /**
   *
   * Paired from three parallel arrays by index, so a short or missing count array cannot shift a tag onto the wrong number.
   */
  sceneLabels: BiomassOverviewDaySceneLabelDto[];
}

export interface BioscopeDayMetricsDto {
  /**
   *
   * Mean camera pitch, in degrees. Only reported by firmware with an IMU.
   */
  bioscopePitchAvg?: number;
  /**
   *
   * Mean camera roll, in degrees. Only reported by firmware with an IMU.
   */
  bioscopeRollAvg?: number;
  /**
   *
   * Mean camera depth, in metres.
   */
  depthAvg?: number;
  /**
   *
   * Deepest depth the camera reported, in metres.
   */
  depthMax?: number;
  /**
   *
   * Shallowest depth the camera reported, in metres.
   */
  depthMin?: number;
  /**
   *
   * Water temperature, in degrees Celsius.
   */
  temperature?: number;
  /**
   *
   * Stereo alignment error, in pixels. A diagnostic, not a fish metric.
   */
  verticalDisparity?: number;
  /**
   *
   * Mean visibility.
   */
  visibilityAvg?: number;
  /**
   *
   * Highest visibility reading.
   */
  visibilityMax?: number;
  /**
   *
   * Lowest visibility reading.
   */
  visibilityMin?: number;
}

export interface BioscopeDetail {
  bioscopeStatusFlag: BioscopeStatusFlag;
  bioscopeVersion: string;
  client: Client;
  clientId: number;
  connection: Connection;
  id: number;
  lastLocation: LastLocation;
  lastMeasurement: LastMeasurement;
  locations: Locations[];
  statusFlags: StatusFlags[];
  version: Version;
  configuration?: BioscopeConfiguration;
  contractId?: number;
  description?: string;
  isTestBioscope?: boolean;
}

export interface BioscopeImage {
  id: string;
  /**
   *
   * - Format: date-time
   */
  timestamp: string;
}

export interface BioscopeImageController_GetImageListQueryParams {
  /**
   *
   * ISO date (YYYY-MM-DD). Defaults to the latest day with images.
   */
  day?: string;
  /**
   *
   * When set (and day is omitted), returns images for the day that contains this id.
   */
  imageId?: string;
}

export interface BioscopeLastLocation {
  cage: BioscopeCage;
  cageId: number;
  id: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface BioscopeLocation {
  bioscopeId: number;
  cages: Cage;
  /**
   *
   * - Format: date-time
   */
  from: string;
}

export interface BioscopeMetadataDto {
  id: number;
  version: string;
  /**
   *
   * - Format: date-time
   */
  lastAlive?: string;
}

export interface BioscopeMovementDto {
  /**
   *
   * Bioscope to move.
   * - minimum: 1
   * - max: 2147483647
   */
  bioscopeId: number;
  /**
   *
   * Cage the bioscope is being moved into. Typically the relocation target.
   * - minimum: 1
   * - max: 2147483647
   */
  targetCageId: number;
}

export interface BioscopeRestart {
  isDone: boolean;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  message?: string;
  /**
   *
   * Set once the shutdown SMS is sent
   */
  shutdownSmsId?: number;
  /**
   *
   * Set once the start SMS is sent
   */
  startSmsId?: number;
}

export interface BioscopeRouterRestart {
  isDone: boolean;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  message?: string;
  /**
   *
   * Set once the router's reply to the reboot SMS arrives
   */
  rebootResponseId?: number;
  /**
   *
   * Set once the reboot SMS is sent
   */
  rebootSmsId?: number;
}

export interface BioscopeStatusFlag {
  /**
   *
   * - Format: date-time
   */
  flagged_at: string;
  id: number;
  status_flag: {
    code?: string;
    color?: string;
    id?: number;
    level?: number;
    name?: string;
  };
  comment?: string;
}

export interface BioscopeStreamSettingsRowDto {
  bioscope: BioscopeMetadataDto;
  cage: CageMetadataDto;
  /**
   *
   * Current daily quota usage in seconds for this bioscope in the location timezone
   */
  currentDailyUsageSeconds: number;
  location: LocationMetadataDto;
  settings: VideoStreamSettingsDto;
}

export interface Bucket {
  from: number;
  to: number;
}

export interface BwWelfareDay {
  day: string;
  averageWoundSize?: number;
  bigWound?: number;
  /**
   *
   * Null on calendar gap days, which have no measurement; so is every metric.
   */
  count?: number;
  matureJaw?: number;
  mediumWound?: number;
  moreThanOneWound?: number;
  noWound?: number;
  notSuperior?: number;
  oneWound?: number;
  skinSpeckles?: number;
  smallWound?: number;
  total?: number;
  wound?: number;
}

export interface BwWelfareMetrics {
  averageWoundSize: number;
  bigWound: number;
  matureJaw: number;
  mediumWound: number;
  moreThanOneWound: number;
  noWound: number;
  notSuperior: number;
  oneWound: number;
  skinSpeckles: number;
  smallWound: number;
  wound: number;
}

export interface BwWelfareResponse {
  /**
   *
   * 3-day running averages, one per calendar day from the first to the last measured day.
   */
  days: BwWelfareDay[];
  /**
   *
   * The last day in `days`; empty when there is none.
   */
  lastDay: string;
  /**
   *
   * The last day's 3-day running average.
   */
  lastEstimate: BwWelfareMetrics;
  slopePerDay: BwWelfareMetrics;
  trend: BwWelfareTrendDay[];
  weekly: BwWelfareWeek[];
}

export interface BwWelfareTrendDay {
  averageWoundSize: number;
  bigWound: number;
  day: string;
  matureJaw: number;
  mediumWound: number;
  moreThanOneWound: number;
  noWound: number;
  notSuperior: number;
  oneWound: number;
  skinSpeckles: number;
  smallWound: number;
  wound: number;
}

export interface BwWelfareWeek {
  averageWoundSize: number;
  bigWound: number;
  isoWeek: number;
  isoYear: number;
  matureJaw: number;
  mediumWound: number;
  moreThanOneWound: number;
  noWound: number;
  notSuperior: number;
  oneWound: number;
  skinSpeckles: number;
  smallWound: number;
  wound: number;
}

export interface Cage {
  id: number;
  locations: CageLicenseLocation;
  name: string;
}

export interface CageActiveFishGroupDto {
  id: number;
  name: string;
  initialPopulationSize?: number;
}

export interface CageActiveFishGroupResponseDto {
  /**
   *
   * Null when no active fish group occupies the cage.
   */
  activeFishGroup?: CageActiveFishGroupDto;
}

export interface CageBioscopeHistoryItemDto {
  /**
   *
   * Bioscope identifier
   * @example
   *   1234
   */
  bioscopeId: number;
  /**
   *
   * Date when bioscope was placed in cage
   * @example
   *   2024-01-15
   */
  from: string;
  /**
   *
   * Date when bioscope left cage (null means current placement)
   * @example
   *   2024-06-30
   */
  to?: string;
}

export interface CageBioscopeStatus {
  cageId: number;
  cageName: string;
  bioscopeId?: number;
  /**
   *
   * - Format: date-time
   */
  lastMeasurement?: string;
  lastMeasurementDaysAgo?: number;
}

export interface CageContextBioscopeDto {
  /**
   *
   * Whether the current bioscope has a winch the portal may control
   */
  winchExists: boolean;
  /**
   *
   * Id of the bioscope currently assigned to the cage. Null when none is.
   * @example
   *   1201
   */
  id?: number;
  /**
   *
   * Hardware version of the current bioscope, falling back to the most recent placement when the cage has no current assignment.
   * @example
   *   2.0
   */
  version?: string;
  /**
   *
   * Winch id of the current bioscope. Null when there is no winch.
   * @example
   *   88
   */
  winchId?: number;
}

export interface CageContextCageDto {
  /**
   *
   * Internal cage id
   * @example
   *   1234
   */
  id: number;
  /**
   *
   * Cage name as shown in the webportal
   * @example
   *   Pen 3
   */
  name: string;
  /**
   *
   * Physical type of the pen. Null for cages predating the cage-type column.
   */
  cageType?: CageContextCageTypeDto;
  /**
   *
   * Cage id in the customer's own system. Null when not integrated.
   * @example
   *   CAGE-003
   */
  externalId?: string;
  /**
   *
   * Cage name in the customer's own system. Null when not integrated.
   * @example
   *   Merd 3
   */
  externalName?: string;
}

export interface CageContextCageTypeDto {
  /**
   *
   * Internal CageType id
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default cage type
   * @example
   *   true
   */
  isDefault: boolean;
  /**
   *
   * CageType name as used in the webportal
   * @example
   *   Open in sea
   */
  name: string;
}

export interface CageContextClientDto {
  /**
   *
   * Feature flags enabled for this client
   * @example
   *   living-weight-all-tags
   */
  featureFlags: string[];
  /**
   *
   * Internal client id
   * @example
   *   7
   */
  id: number;
  /**
   *
   * Client name
   * @example
   *   Example Seafood AS
   */
  name?: string;
}

export interface CageContextDataAvailabilityDto {
  /**
   *
   * Whether the cage has any colour-welfare data at all
   * @example
   *   true
   */
  hasColorWelfare: boolean;
  /**
   *
   * Day of the earliest daily measurement, `YYYY-MM-DD`. Null when the cage has never been measured.
   * @example
   *   2024-03-05
   */
  firstMeasurementDay?: string;
  /**
   *
   * Day the cage was marked historical (harvested / no longer measured), `YYYY-MM-DD`. Null means the cage is not historical.
   * @example
   *   2025-11-20
   */
  historicalSince?: string;
}

export interface CageContextFishTypeDto {
  /**
   *
   * Internal fish type id
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Fish type name
   * @example
   *   Atlantic salmon
   */
  name: string;
  /**
   *
   * Short code used for UI branching
   * @example
   *   SALMON
   */
  shortName: string;
}

export interface CageContextLiceTypeDto {
  /**
   *
   * Internal lice type id
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default lice type
   * @example
   *   true
   */
  isDefault: boolean;
  /**
   *
   * Lice type name
   * @example
   *   Salmon louse
   */
  name: string;
  /**
   *
   * Short code used for UI branching
   * @example
   *   NO
   */
  shortName: string;
}

export interface CageContextLicenseDto {
  /**
   *
   * Licence code the UI gates features on
   * @example
   *   FISH_HEALTH.MIN
   */
  code: string;
  /**
   *
   * First day the licence covers this cage, `YYYY-MM-DD`
   * @example
   *   2025-01-01
   */
  from: string;
  /**
   *
   * Last day the licence covers this cage, `YYYY-MM-DD`
   * @example
   *   2026-12-31
   */
  to: string;
}

export interface CageContextLocationDto {
  /**
   *
   * Internal location id
   * @example
   *   42
   */
  id: number;
  /**
   *
   * Site type. Always present — the column is NOT NULL with a default.
   */
  locationType: CageContextLocationTypeDto;
  /**
   *
   * Location name
   * @example
   *   Hitra Nord
   */
  name: string;
  /**
   *
   * IANA timezone the location reports its days in
   * @example
   *   Europe/Oslo
   */
  timezone: string;
}

export interface CageContextLocationTypeDto {
  /**
   *
   * Internal location type id
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Location type name
   * @example
   *   Sea
   */
  name: string;
  /**
   *
   * Short code used for UI branching
   * @example
   *   SEA
   */
  shortName: string;
}

export interface CageContextResponseDto {
  /**
   *
   * The bioscope currently in the pen
   */
  bioscope: CageContextBioscopeDto;
  /**
   *
   * The static physical pen
   */
  cage: CageContextCageDto;
  /**
   *
   * The site owner
   */
  client: CageContextClientDto;
  /**
   *
   * Which data this cage has
   */
  dataAvailability: CageContextDataAvailabilityDto;
  /**
   *
   * Licence codes unlocking UI for this cage, deduplicated and sorted. Multiple windows for one code are kept.
   */
  licenses: CageContextLicenseDto[];
  /**
   *
   * The site the pen sits at
   */
  location: CageContextLocationDto;
  /**
   *
   * What is currently in the pen
   */
  stock: CageContextStockDto;
}

export interface CageContextStockDto {
  /**
   *
   * Lice variant to count and report. Always present — the column is NOT NULL with a default.
   */
  liceType: CageContextLiceTypeDto;
  /**
   *
   * Slaughter (gutted) weight percentage used to derive gutted weight
   * @example
   *   17
   */
  sWeightPct: number;
  /**
   *
   * Species in the pen. Null when the location has no fish type set (the column is nullable).
   */
  fishType?: CageContextFishTypeDto;
}

export interface CageController_ContextQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface CageController_OverviewQueryParams {
  /**
   *
   * Daypart the period aggregates and the scene labels are computed for. Defaults to `day`.
   */
  daypartTag?: string;
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Start of the range (inclusive), ISO 8601 (YYYY-MM-DD). Omitted opens a 28-day window ending on the last measured day.
   */
  from?: string;
  /**
   *
   * End of the range (inclusive), ISO 8601 (YYYY-MM-DD).
   */
  to?: string;
  /**
   *
   * Set to false to bypass the ten-minute cache for this request, both reading and writing.
   */
  useCache?: boolean;
}

export interface CageController_getHealthOverviewQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface CageController_getWeightDistributionsQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Start date for weight distributions (inclusive) in ISO 8601 format (YYYY-MM-DD)
   */
  from?: string;
  /**
   *
   * End date for weight distributions (inclusive) in ISO 8601 format (YYYY-MM-DD)
   */
  to?: string;
}

export interface CageController_getWelfareOverviewQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface CageDashboardHealthAlertDto {
  level: "high" | "increasing" | "stable";
  /**
   *
   * Sort key for alert severity (higher = more severe).
   */
  priority: number;
}

export interface CageDashboardHealthParameterDto {
  alert: CageDashboardHealthAlertDto;
  key:
    | "bodyWounds"
    | "snoutWounds"
    | "scaleLoss"
    | "skinBleeding"
    | "finDamage"
    | "emaciation"
    | "deformity"
    | "deformedJaw"
    | "gillLid"
    | "cataract"
    | "eyeDamage"
    | "maturity";
  scores: CageDashboardHealthScoresDto;
}

export interface CageDashboardHealthScoresDto {
  /**
   *
   * Latest-day share of fish with Laksvel score 0 (0–1).
   */
  score0?: number;
  /**
   *
   * Latest-day share of fish with Laksvel score 1 (0–1).
   */
  score1?: number;
  /**
   *
   * Latest-day share of fish with Laksvel score 2 (0–1).
   */
  score2?: number;
  /**
   *
   * Latest-day share of fish with Laksvel score 3 (0–1).
   */
  score3?: number;
}

export interface CageDepthSeriesController_getCageDepthSeriesQueryParams {
  /**
   *
   * First calendar day, inclusive, YYYY-MM-DD.
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  from: string;
  /**
   *
   * hour reads environment_sensor_data_hourly and is limited to 31 days. day reads the daily aggregate.
   */
  resolution: "hour" | "day";
  /**
   *
   * Last calendar day, inclusive, YYYY-MM-DD.
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  to: string;
}

export interface CageDepthSeriesDto {
  /**
   * @example
   *   1
   */
  cageId: number;
  /**
   * @example
   *   Pen 1
   */
  name: string;
  points: DepthPointDto[];
}

export interface CageFishGroupHistoryItemDto {
  /**
   *
   * ID of the fish group that lived in this cage during the period.
   */
  fishGroupId: number;
  /**
   *
   * Name of the fish group at the time of read.
   */
  fishGroupName: string;
  /**
   *
   * When the fish group was placed in this cage.
   * - Format: date-time
   */
  fromDate: string;
  /**
   *
   * Current lifecycle status of the fish group. Reflects the latest status, not the status at the time of the location row.
   */
  status:
    | "pending"
    | "active"
    | "closed"
    | "discarded"
    | "harvested"
    | "merged"
    | "split";
  /**
   *
   * Operator-provided reason for this placement / closure.
   */
  reason?: string;
  /**
   *
   * When the fish group left this cage. Null when this is the currently-open occupation.
   * - Format: date-time
   */
  toDate?: string;
}

export interface CageHealthAlertOverviewDto {
  level: "high" | "increasing";
  parameterKey:
    | "bodyWounds"
    | "snoutWounds"
    | "scaleLoss"
    | "skinBleeding"
    | "finDamage"
    | "emaciation"
    | "deformity"
    | "deformedJaw"
    | "gillLid"
    | "cataract"
    | "eyeDamage"
    | "maturity";
  /**
   *
   * Latest-day Laksvel index (0–1) for tooltip display.
   */
  index?: number;
}

export interface CageHealthOverviewDto {
  /**
   *
   * Non-stable parameters from the latest day, highest priority first.
   */
  alerts: CageHealthAlertOverviewDto[];
  /**
   *
   * Day of the latest estimate the summary was built from (`YYYY-MM-DD`).
   * @example
   *   2026-04-20
   */
  day?: string;
  /**
   *
   * Latest-day downgrade share (`not_superior`, 0–1), matching legacy welfare `downgradeRate`.
   */
  downgradeRate?: number;
  /**
   *
   * Highest-priority alert parameter on the latest day, if any.
   */
  topAlertParameterKey?:
    | "bodyWounds"
    | "snoutWounds"
    | "scaleLoss"
    | "skinBleeding"
    | "finDamage"
    | "emaciation"
    | "deformity"
    | "deformedJaw"
    | "gillLid"
    | "cataract"
    | "eyeDamage"
    | "maturity";
  /**
   *
   * Latest-day wound prevalence (`any_wound`, 0–1), matching legacy welfare `woundRate`.
   */
  woundRate?: number;
  /**
   *
   * Weekly `any_wound` trend (0–1), from precomputed per-day `any_wound_slope` on the latest estimate (× 7). Matches legacy welfare `woundSlope`.
   */
  woundSlope?: number;
}

export interface CageHealthOverviewResponseDto {
  /**
   *
   * Latest-day Laksvel score bars and alerts for the Cage Dashboard card.
   */
  parameters: CageDashboardHealthParameterDto[];
  /**
   *
   * Latest estimate day (`YYYY-MM-DD`), shown as last measurement on the card.
   * @example
   *   2026-04-20
   */
  lastMeasurement?: string;
}

export interface CageHistoricalChange {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId: number;
  /**
   *
   * True marks the pen historical; false makes it current again
   */
  historical: boolean;
}

export interface CageHistoricalDto {
  id: number;
  name: string;
  /**
   *
   * Null once the pen is current again
   * - Format: date-time
   */
  historical?: string;
  locationId?: number;
}

export interface CageImage {
  id: string;
  /**
   *
   * - Format: date-time
   */
  timestamp: string;
}

export interface CageImageController_GetImageListQueryParams {
  /**
   *
   * ISO date (YYYY-MM-DD). Defaults to the latest day with images.
   */
  day?: string;
  /**
   *
   * When set (and day is omitted), returns images for the day that contains this id.
   */
  imageId?: string;
}

export interface CageLicenseLocation {
  id: number;
  name: string;
}

export interface CageListItemDto {
  /**
   *
   * Historical bioscope placements for this cage
   */
  bioscopeHistory: CageBioscopeHistoryItemDto[];
  /**
   *
   * Cage identifier
   * @example
   *   12
   */
  id: number;
  /**
   *
   * Cage display name
   * @example
   *   Cage A-12
   */
  name: string;
  /**
   *
   * Derived cage status
   * @example
   *   active
   */
  status: "active" | "inactive" | "historical";
  /**
   *
   * The fish group in this pen now, or null for an empty pen. Links into the pen carry its id so they open on the cohort rather than the pen-wide legacy view.
   */
  activeFishGroup?: OverviewFishGroupSummaryDto;
  /**
   *
   * Cage type name
   * @example
   *   open_in_sea
   */
  cageType?: string;
  /**
   *
   * Client identifier
   * @example
   *   10
   */
  clientId?: number;
  /**
   *
   * Client display name
   * @example
   *   Mowi
   */
  clientName?: string;
  /**
   *
   * Current bioscope id if assigned
   * @example
   *   5678
   */
  currentBioscopeId?: number;
  /**
   *
   * External cage id
   * @example
   *   CAGE-EXT-42
   */
  externalId?: string;
  /**
   *
   * External cage name
   * @example
   *   External Cage Name
   */
  externalName?: string;
  /**
   *
   * First measurement day available for this cage
   * @example
   *   2023-11-01
   */
  firstMeasurement?: string;
  /**
   *
   * Species in this pen. A location can hold several, so this is the pen's own value, not the location default.
   * @example
   *   salmon
   */
  fishType?: string;
  /**
   *
   * Date when cage was marked historical
   * @example
   *   2025-01-10
   */
  historicalAt?: string;
  /**
   *
   * Last measurement day available for this cage
   * @example
   *   2026-04-27
   */
  lastMeasurement?: string;
  /**
   *
   * Location identifier
   * @example
   *   99
   */
  locationId?: number;
  /**
   *
   * Location display name
   * @example
   *   Austevoll
   */
  locationName?: string;
}

export interface CageMetadataDto {
  id: number;
  name: string;
}

export interface CageOverviewDataDto {
  /**
   *
   * Health module summary from latest welfare color estimate
   */
  health?: CageHealthOverviewDto;
  /**
   *
   * Lice data
   */
  lice?: LiceOverviewDto;
  /**
   *
   * Swim speed measurement
   */
  swimSpeed?: SwimSpeedOverviewDto;
  /**
   *
   * Weight data
   */
  weight?: WeightOverviewDto;
  /**
   *
   * Welfare data
   */
  welfare?: WelfareOverviewDto;
}

export interface CageOverviewDto {
  /**
   *
   * List of active bioscope IDs
   */
  activeBioscopes: array[];
  /**
   *
   * Cage measurement data
   */
  cageData: CageOverviewDataDto;
  /**
   *
   * Cage ID
   */
  cageId: number;
  /**
   *
   * Cage name
   */
  cageName: string;
  cageType: CageType;
  /**
   *
   * Fish group currently occupying the cage. Present only when includeFishGroups=true.
   */
  activeFishGroup?: OverviewFishGroupSummaryDto;
  /**
   *
   * Bioscope version for the cage’s current bioscope assignment. Omitted when no bioscope is assigned. Used to choose welfare vs health overview UI.
   * @example
   *   2.0
   */
  bioscopeVersion?: string;
  /**
   *
   * The species in this pen, as stored. A location can hold several, so per-pen behaviour must use this rather than the location's value. Null when unknown.
   */
  fishType?: FishTypeInfo;
  /**
   *
   * ISO date when the cage was marked historical, null otherwise
   * @example
   *   2024-01-15T00:00:00.000Z
   */
  historicalSince?: string;
}

export interface CageStatus {
  currentBioscope: {
    id?: number;
    /**
     *
     * - Format: date-time
     */
    lastAlive?: string;
  };
  historicalBioscopes: HistoricalBioscope[];
  lastData: {
    depthLast?: number;
    /**
     *
     * - Format: date-time
     */
    lastAlive?: string;
    /**
     *
     * - Format: date-time
     */
    lastMoveFromDate?: string;
    pitchLast?: number;
    rollLast?: number;
    /**
     *
     * - Format: date-time
     */
    timestampLast?: string;
  };
}

/**
 *
 * Cage type identifier
 */

export enum CageType {
  open_in_sea = "open_in_sea",
  submerged = "submerged",
  smolt_production = "smolt_production",
  closed_in_sea = "closed_in_sea",
  landbased = "landbased",
  other = "other",
}

export interface CageTypeDto {
  /**
   *
   * Internal CageType id
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Setting Default Cage type which is "Open in sea"
   * @example
   *   true
   */
  isDefault: boolean;
  /**
   *
   * CageType name as used in the webportal
   * @example
   *   Open in sea
   */
  name: string;
}

export interface CageTypeInfo {
  /**
   *
   * Cage type ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default cage type
   * @example
   *   true
   */
  is_default: boolean;
  /**
   *
   * Cage type name
   * @example
   *   Open in sea
   */
  name: string;
}

export interface CageWelfareOverviewResponseDto {
  /**
   *
   * Latest swim speed measurement
   */
  swimSpeed?: SwimSpeedOverviewDto;
  /**
   *
   * Welfare summary for the cage
   */
  welfare?: WelfareOverviewDto;
}

export interface ClarifyCatalogDto {
  /**
   *
   * Sorted by name.
   */
  items: ClarifyCatalogItemDto[];
  status: ClarifyCatalogStatus;
  /**
   *
   * True when Clarify returned a full page of 1000 items.
   */
  truncated: boolean;
  reason?: ClarifyCatalogReason;
}

export interface ClarifyCatalogItemDto {
  /**
   * @example
   *   aaaaaaaaaaaaaaaaaa10
   */
  id: string;
  /**
   *
   * One `key: value, value` text per label key.
   */
  labels: string[];
  name: string;
  engUnit?: string;
}

/**
 *
 * A cause the page words itself, beyond the status; null for none.
 */

export enum ClarifyCatalogReason {
  timed_out = "timed_out",
  too_large = "too_large",
  unreadable_answer = "unreadable_answer",
}

export interface ClarifyCatalogRequestDto {
  /**
   *
   * Unsaved site fields, e.g. `base_url`, `token_url`.
   */
  connection?: FieldPatchDto[];
  /**
   *
   * Unsaved set-for-all secrets.
   */
  secrets?: SecretsPatchDto;
}

/**
 *
 * How Clarify answered, classified as the connection test does. Anything but `ok` comes with no items.
 */

export enum ClarifyCatalogStatus {
  ok = "ok",
  auth_failed = "auth_failed",
  unreachable = "unreachable",
  error = "error",
}

export interface ClientContract {
  description: string;
  id: number;
}

export interface ClientController_AllLiceDailyReportQueryParams {
  day: string;
  locationId: number;
}

export interface ClientController_AllLiceDailyReportsQueryParams {
  day: string;
}

export interface ClientController_AllLiceWeeklyReportQueryParams {
  /**
   *
   * Implementation to answer with. Omit for the one that ships today.
   */
  source?: "sql" | "core" | "compare";
}

export interface ClientController_OverviewQueryParams {
  /**
   *
   * Show the overview from the point of view of the fish groups: cages placed by the group living in them (empty without one) and filled with its data, plus closed cohorts per location. Omit for the pre-fish-groups response.
   */
  includeFishGroups?: boolean;
}

export interface ClientController_RangeLiceReportQueryParams {
  from: string;
  locationId: number;
  to: string;
}

export interface ClientController_RangeLiceReportsQueryParams {
  from: string;
  to: string;
}

export interface ClientFishGroupsOverviewDto {
  /**
   *
   * Locations that have at least one active cage (a cage with a bioscope).
   */
  activeLocations: OverviewLocationDto[];
  clientId: number;
  /**
   *
   * Locations whose cages are all inactive (no bioscope assigned).
   */
  inactiveLocations: OverviewLocationDto[];
}

export interface ClientInfo {
  featureFlags: string[];
  id: number;
  name: string;
  archived?: boolean;
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
}

export interface ClientIntegrationRowDto {
  cageId: number;
  cageName: string;
  isActive: boolean;
  locationId: number;
  locationName: string;
  providerName: string;
  rowId: number;
  /**
   *
   * ISO 8601, UTC: newest fetch over the last 30 days.
   */
  lastFetchedAt?: string;
}

export interface ClientLicenseResponse {
  clientId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  licenseId: number;
  numLicenses: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface ClientLicenseUser {
  clientUsers: LicenseClientUser[];
  emailConfirmed: boolean;
  id: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  systemRole?: string;
}

export interface ClientLicenseWithLicense {
  clientId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  licenseId: number;
  licenses: LicenseRecord;
  numLicenses: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface ClientLocationCages {
  cageTypes: CageTypeInfo;
  current_bioscope: { bioscopeId?: number };
  id: number;
  name: string;
  /**
   *
   * Species in this pen. Null when neither the pen nor its location records one.
   */
  fishTypes?: FishTypeInfo;
  /**
   *
   * - Format: date-time
   */
  historical?: string;
}

export interface ClientLocations {
  aquacultureSiteId: number;
  cages: ClientLocationCages[];
  id: number;
  latitude: number;
  lice_type: LiceTypeInfo;
  location_type: LocationTypeInfo;
  longitude: number;
  name: string;
  timezone: string;
  /**
 * 
 * Default species for new pens at this site. Null when none is recorded; a pen's own
 value is authoritative regardless (WB-2207).
 */
  fishTypes?: FishTypeInfo;
}

export interface ClientOverviewResponseDto {
  /**
   *
   * Locations with at least one active cage, sorted by name
   */
  activeLocations: LocationOverviewDto[];
  /**
   *
   * Client ID
   */
  clientId: number;
  /**
   *
   * Locations whose cages are all inactive or historical, sorted by name
   */
  inactiveLocations: LocationOverviewDto[];
}

export interface ClientSummaryDto {
  /**
   *
   * Names of the license types with a license running today
   */
  activeLicenses: string[];
  /**
   *
   * API users created for the client
   */
  apiUserCount: number;
  /**
   *
   * Whether the client is archived
   */
  archived: boolean;
  /**
   *
   * Bioscopes currently placed for the client, test bioscopes excluded
   */
  bioscopeCount: number;
  /**
   *
   * Contracts that are not archived
   */
  contractCount: number;
  /**
   *
   * Bioscopes licensed across the contracts that are not archived
   */
  contractedBioscopeCount: number;
  /**
   *
   * When the client was created (ISO 8601)
   */
  createdAt: string;
  /**
   *
   * Names of the active license types whose running licenses all end within 30 days
   */
  expiringLicenses: string[];
  /**
   *
   * Feature flags enabled for the client
   */
  featureFlags: string[];
  /**
   *
   * Client ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Data integrations in use, e.g. Aquagroup, Mercatus or an external provider
   */
  integrations: string[];
  /**
   *
   * Names of the license types that had a license and have none running or about to start. A type renewed by a newer license is not lapsed
   */
  lapsedLicenses: string[];
  /**
   *
   * Client name
   * @example
   *   Lerøy Midt
   */
  name: string;
  /**
   *
   * Pens (cages) that are not deleted, across all sites
   */
  penCount: number;
  /**
   *
   * Sites (locations) that are not deleted
   */
  siteCount: number;
  /**
   *
   * Placed bioscopes with no measurement within the online threshold (28 hours), including those that never measured
   */
  staleBioscopeCount: number;
  /**
   *
   * All contracts for the client, including archived ones
   */
  totalContractCount: number;
  /**
   *
   * Users with access to the client
   */
  userCount: number;
  /**
   *
   * Latest measurement from any placed bioscope (ISO 8601)
   */
  lastMeasurementAt?: string;
  /**
   *
   * Earliest license end date (YYYY-MM-DD) that is today or later; when every license has ended, the latest one that did. Null when the client has no contract licenses
   */
  nextLicenseExpiry?: string;
}

export interface ClientUserRecord {
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  locationIds: number[];
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  clientId?: number;
  role?: string;
  userId?: number;
}

export interface ClientWithLocations {
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  featureFlags: string[];
  id: number;
  locations: LicenseClientLocation[];
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  archived?: boolean;
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
  living_weight_adj_pct?: number;
  name?: string;
}

export interface ClientWithLocationsInfo {
  contract: ClientContract[];
  id: number;
  locations: ClientLocations[];
  name: string;
}

export interface CloseFishGroupRequest {
  reason: CloseReason;
  /**
   *
   * When the close happened. Defaults to the current server time. Must be ISO 8601.
   */
  closedDate?: string;
  notes?: string;
}

export enum CloseReason {
  harvested = "harvested",
  decommissioned = "decommissioned",
  operational = "operational",
  other = "other",
}

export interface ClosedFishGroupRowDto {
  /**
   *
   * Cage the cohort lived in
   */
  cageId: number;
  /**
   *
   * Name of that cage
   */
  cageName: string;
  fishGroupId: number;
  fishGroupName: string;
  /**
   *
   * Arrival in the cage
   * - Format: date-time
   */
  fromDate: string;
  /**
   *
   * Departure from the cage
   * - Format: date-time
   */
  toDate: string;
}

export interface CompareBehaviorMetricsDto {
  /**
   *
   * Swim speed per cage per day (bl/s)
   */
  swimSpeed: CompareMetricDto;
}

export interface CompareBiomassMetricsDto {
  /**
   *
   * Condition factor per cage per day
   */
  conditionFactor: CompareMetricDto;
  /**
   *
   * Coefficient of variation per cage per day (ratio)
   */
  cv: CompareMetricDto;
  /**
   *
   * Living weight per cage per day (grams)
   */
  weight: CompareMetricDto;
}

export interface CompareCageDto {
  /**
   *
   * Cage ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Cage name
   * @example
   *   Pen 1
   */
  name: string;
  /**
   *
   * Only with `includeFishGroups`: the active fish group this cage's series were read for, or null when the cage holds none and was compared on its own data.
   */
  activeFishGroup?: CompareFishGroupDto;
}

export interface CompareController_getLocationCompareQueryParams {
  /**
   *
   * Daypart tag (defaults to "day")
   */
  daypartTag?: DaypartTag;
  /**
   *
   * Start date in YYYY-MM-DD format. If omitted, no lower date limit is applied.
   */
  from?: string;
  /**
   *
   * Show the overview from the point of view of the fish groups: cages placed by the group living in them (empty without one) and filled with its data, plus closed cohorts per location. Omit for the pre-fish-groups response.
   */
  includeFishGroups?: boolean;
  /**
   *
   * End date in YYYY-MM-DD format. If omitted, no upper date limit is applied.
   */
  to?: string;
}

export interface CompareDataPointDto {
  /**
   *
   * Day in YYYY-MM-DD format
   * @example
   *   2024-01-15
   */
  day: string;
  /**
   *
   * Map cageId → raw value for this day. null when no measurement.
   * @example
   *   [object Object]
   */
  values: { [x: string]: number };
}

export interface CompareEnvironmentMetricsDto {
  /**
   *
   * Average camera depth per cage per day (metres). Omitted when no cage reported a value in the range.
   */
  averageDepth?: CompareMetricDto;
  /**
   *
   * Oxygen concentration per cage per day (mg/L). Omitted when no cage reported a value in the range.
   */
  oxygenConcentration?: CompareMetricDto;
  /**
   *
   * Oxygen saturation per cage per day (percent 0–100). Omitted when no cage reported a value in the range.
   */
  oxygenSaturation?: CompareMetricDto;
  /**
   *
   * Salinity per cage per day (PSU). Omitted when no cage reported a value in the range.
   */
  salinity?: CompareMetricDto;
  /**
   *
   * Water temperature per cage per day (°C). Omitted when no cage reported a value in the range.
   */
  temperature?: CompareMetricDto;
}

export interface CompareFishGroupDto {
  /**
   *
   * Fish group ID
   * @example
   *   42
   */
  id: number;
  /**
   *
   * Fish group name
   * @example
   *   FG-P1-26A
   */
  name: string;
}

export interface CompareLiceMetricsDto {
  /**
   *
   * Caligus elongatus (legacy avg) per cage per day
   */
  caligus: CompareMetricDto;
  /**
   *
   * Female lice (legacy avg) per cage per day
   */
  female: CompareMetricDto;
  /**
   *
   * Moving stage lice (legacy avg) per cage per day
   */
  moving: CompareMetricDto;
}

export interface CompareMaturationMetricsDto {
  /**
   *
   * Fully mature rate per cage per day (ratio 0–1)
   */
  fullyMature: CompareMetricDto;
}

export interface CompareMetricDto {
  /**
   *
   * Daily data points for this metric, sorted ascending by day
   */
  dataPoints: CompareDataPointDto[];
}

export interface CompareMetricsDto {
  /**
   *
   * Behavior metrics. Omitted when the location has no fish-speed license.
   */
  behavior?: CompareBehaviorMetricsDto;
  /**
   *
   * Biomass metrics. Omitted when the location has no biomass license.
   */
  biomass?: CompareBiomassMetricsDto;
  /**
   *
   * Environmental metrics from the bioscope sensors (daily averages). Not licence-gated. The group is omitted when no cage has environmental data; individual metrics (e.g. salinity) are omitted when no cage reported a value in the range. The compare page still lists omitted environmental params as disabled options.
   */
  environment?: CompareEnvironmentMetricsDto;
  /**
   *
   * Lice metrics. Omitted when the location has no lice license.
   */
  lice?: CompareLiceMetricsDto;
  /**
   *
   * Maturation metrics. Omitted when the location has no fish-health license.
   */
  maturation?: CompareMaturationMetricsDto;
  /**
   *
   * Wound metrics. Omitted when the location has no fish-health license.
   */
  wounds?: CompareWoundsMetricsDto;
}

export interface CompareWoundsMetricsDto {
  /**
   *
   * Active (acute) wound rate per cage per day (ratio 0–1)
   */
  active: CompareMetricDto;
  /**
   *
   * Any wound rate per cage per day (ratio 0–1)
   */
  any: CompareMetricDto;
  /**
   *
   * Healing wound rate (`num_healing_wounds`, as Health shows it) per cage per day (ratio 0–1)
   */
  healing: CompareMetricDto;
  /**
   *
   * Large (big) wound rate per cage per day (ratio 0–1)
   */
  large: CompareMetricDto;
  /**
   *
   * Medium wound rate per cage per day (ratio 0–1)
   */
  medium: CompareMetricDto;
  /**
   *
   * Small wound rate per cage per day (ratio 0–1)
   */
  small: CompareMetricDto;
}

export interface CompleteTaskDto {
  /**
   *
   * - maxLength: 1000
   */
  comment?: string;
}

export interface Connection {
  active: string;
  cabinet: number;
  id: number;
  ip: string;
  /**
   *
   * - Format: date-time
   */
  lastSeen: string;
  phoneNumber: string;
  router: string;
  internetSource?: string;
  wanIp?: string;
}

export interface ConnectionValueDto {
  key: string;
  perPen: PenFieldValueDto[];
  /**
   *
   * Whether the pens of the site hold different values.
   */
  varies: boolean;
  /**
   *
   * Null when the pens disagree. Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  list?: string[];
  /**
   *
   * Null when the pens disagree. Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  text?: string;
}

export interface Contract {
  bioscopeLocations: BioscopeLocation[];
  clientId: number;
  count: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  description: string;
  id: number;
  licenses: ContractLicense[];
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
}

export interface ContractLicense {
  /**
   *
   * - Format: date-time
   */
  dayFrom: string;
  /**
   *
   * - Format: date-time
   */
  dayTo: string;
  id: number;
  license: LicenseInfo;
}

export interface ContractLicenseRecord {
  contractId: number;
  /**
   *
   * - Format: date-time
   */
  created_at: string;
  /**
   *
   * - Format: date-time
   */
  dayFrom: string;
  /**
   *
   * - Format: date-time
   */
  dayTo: string;
  id: number;
  licenseId: number;
  /**
   *
   * - Format: date-time
   */
  updated_at: string;
}

export interface ContractRecord {
  clientId: number;
  count: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  updated_at: string;
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
  description?: string;
}

export interface CreateApiUserInput {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  accessLevelId: number;
  allowedCageIds?: number[];
  allowedLocationIds?: number[];
}

export interface CreateApiUserResponse {
  accessLevelId: number;
  allowedCageIds: number[];
  allowedLocationIds: number[];
  clientId: number;
  createdAt: string;
  id: number;
  password: string;
  comment?: string;
  lastUsed?: string;
  updatedAt?: string;
}

export interface CreateBioscope {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  bioscopeId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId?: number;
}

export interface CreateCagesDto {
  /**
   *
   * Cage type id applied to all created cages
   * - minimum: 1
   * - max: 2147483647
   */
  cageTypeId: number;
  /**
   *
   * Location to create cages in
   * - minimum: 1
   * - max: 2147483647
   */
  locationId: number;
  /**
   *
   * Names for each cage to create
   */
  names: string[];
  /**
   *
   * External id applied when creating a single cage
   */
  externalId?: string;
  /**
   *
   * External name applied when creating a single cage
   */
  externalName?: string;
  /**
   *
   * Species in this pen. Omit to inherit the location default; a location may hold several species.
   * - minimum: 1
   * - max: 2147483647
   * @example
   *   2
   */
  fishTypeId?: number;
}

export interface CreateCagesResponse {
  /**
   *
   * IDs of newly created cages
   */
  ids: number[];
}

export interface CreateFishGroupRequest {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId: number;
  name: string;
  /**
   *
   * The group’s species (fishTypes.id). Defaults to salmon when omitted; null is rejected. Describes the group, not the pen.
   * - minimum: 1
   * - max: 2147483647
   */
  fishTypeId?: number;
  /**
   *
   * - minimum: 1
   */
  initialPopulationSize?: number;
  notes?: string;
  /**
   *
   * Free-text reason (e.g. "smolt arrival", "legacy data import").
   */
  reason?: string;
  /**
   *
   * When the fish_group was placed in the cage. Defaults to the current server time. Must be ISO 8601. May be at most one calendar month in the past (from the start of that UTC day); any future date is allowed.
   */
  startDate?: string;
  /**
   *
   * The stocking cycle the group is created in: a planned or active cycle at the cage’s site. Required unless the caller is an Optoscale admin. Omit it rather than sending null.
   * - minimum: 1
   * - max: 2147483647
   */
  stockingCycleId?: number;
}

export interface CreateManualActivityDto {
  /**
   *
   * - maxLength: 255
   */
  title: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  /**
   *
   * - maxLength: 1000
   */
  comment?: string;
  /**
   *
   * - maxLength: 2000
   */
  description?: string;
  performedAt?: string;
}

export interface CreateNewClientInput {
  name: string;
}

export interface CreateNewContractInput {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId: number;
  count: number;
  description: string;
}

export interface CreateNewContractLicenseInput {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  licenseId: number;
  /**
   *
   * - Format: date-time
   */
  dayFrom?: string;
  /**
   *
   * - Format: date-time
   */
  dayTo?: string;
}

export interface CreateNewLicenseForClientInput {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  licenseId: number;
  numLicenses: number;
}

export interface CreateSmoltReportDto {
  /**
   *
   * Delivery date in YYYY-MM-DD format
   * @example
   *   2024-02-25
   */
  deliveryDate: string;
  /**
   *
   * Stocking date in YYYY-MM-DD format
   * @example
   *   2024-01-15
   */
  stockingDate: string;
  /**
   * @example
   *   bodyWounds,finDamage,gillLid,scaleLoss
   */
  laksvelParameters?: SmoltLaksvelParameter[];
  /**
   *
   * Last feeding date in YYYY-MM-DD format
   * @example
   *   2024-02-20
   */
  lastFeedingDate?: string;
}

export interface CreateStockingCycleRequest {
  /**
   *
   * Unique per site, ignoring case. When omitted, the season convention is used (e.g. 26A), from plannedStartDate or else today, suffixed when taken.
   * - maxLength: 255
   */
  name?: string;
  notes?: string;
  /**
   *
   * - Format: date
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   * @example
   *   2026-08-01
   */
  plannedStartDate?: string;
}

export interface CreatedClientDto {
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  featureFlags: string[];
  id: number;
  archived?: boolean;
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
  name?: string;
}

export interface CredentialStatusDto {
  name: ProviderSecretName;
  state: ProviderCredentialState;
  /**
   *
   * ISO 8601, UTC: when the portal last replaced it on any pen. Null when it was set elsewhere or never.
   */
  changedAt?: string;
}

export interface CustomerBannerMessage {
  content: LocalizedString;
  endDate: string;
  environment: "development" | "staging" | "production";
  id: string;
  showOnAllPages: boolean;
  startDate: string;
  targeting: string[];
  title: LocalizedString;
  variant: "neutral" | "informative" | "warning";
}

export interface DailyCageWeightDto {
  cageId: number;
  cageName: string;
  estimatedWeight: number;
  numberOfMeasurements: number;
}

export interface DailyClientReportResult {
  /**
   *
   * Day the report covers.
   * @example
   *   2026-06-01
   */
  day: string;
  /**
   *
   * Every location of the client the requesting user may see.
   */
  locations: LiceReportLocations[];
}

export interface DailyLaksvelScoreResponseDto {
  day: string;
  score1?: number;
  score2?: number;
  score3?: number;
}

export interface DailyLiceCount {
  /**
   *
   * Fish counted over the three-day window backing this average.
   * @example
   *   214
   */
  count: number;
  /**
   *
   * Fish in the window on which no lice were detected.
   * @example
   *   189
   */
  countNoLice: number;
  /**
   *
   * Day the average is centred on.
   * - Format: date-time
   * @example
   *   2026-06-01
   */
  day: string;
  /**
   *
   * Adult female lice per fish.
   * @example
   *   0.12
   */
  femaleAvg: number;
  /**
   *
   * Adult female lice per fish under the pre-cut-over model.
   * @example
   *   0.1
   */
  femaleLegacyAvg: number;
  /**
   *
   * Mobile-stage lice per fish.
   * @example
   *   0.31
   */
  movingStageAvg: number;
  /**
   *
   * Mobile-stage lice per fish under the pre-cut-over model.
   * @example
   *   0.28
   */
  movingStageLegacyAvg: number;
  /**
   *
   * Lice detected across the window.
   * @example
   *   67
   */
  total: number;
  /**
   *
   * Caligus elongatus per fish. Absent for Chilean-lice locations.
   * @example
   *   0.04
   */
  caligusElongatusAvg?: number;
  /**
   *
   * Caligus elongatus per fish under the pre-cut-over model.
   * @example
   *   0.03
   */
  caligusElongatusLegacyAvg?: number;
  /**
   *
   * Sea temperature measured on this day, in the same daypart and for the same subject (the pen the fish group was in that day). Null when the day has no reading.
   * @example
   *   8.4
   */
  temperature?: number;
}

export interface DailyLiceCountResponseDto {
  days: DailyLiceCount[];
  /**
   *
   * Which implementation actually answered, after the server applied its own rules — a fish group always resolves to `core`, whatever was asked for, and a `compare` whose `core` side failed reports `sql`, because that is whose numbers were served. Always present, so a flag-driven rollout can be read off the response instead of inferred.
   */
  source: "sql" | "core" | "compare";
  /**
   *
   * Only for `source=compare`: how the two implementations differed.
   */
  parity?: LiceParityDto;
}

export interface DailyQuotaAvailabilityDto {
  /**
   *
   * Seconds the bioscope may stream per day
   */
  dailyLimit: number;
  quotaAvailable: boolean;
  remainingSeconds: number;
  bioscopeVersion?: string;
  /**
   *
   * Seconds streamed today
   */
  used?: number;
}

export interface DailyReportResult {
  /**
   *
   * Day the report covers.
   * @example
   *   2026-06-01
   */
  day: string;
  location: LiceReportLocations;
}

export interface DailyWeightTimeSeriesResponseDto {
  day: string;
  cv?: number;
  fishHeight?: number;
  fishLength?: number;
  growth?: number;
  liveWeight?: number;
  liveWeightTrend?: number;
  /**
   *
   * Fish measured that day. Null on reports stored before the daily count was kept.
   */
  numMeasurements?: number;
  sgr?: number;
}

export interface DailyWoundsResponseDto {
  day: string;
  acute?: number;
  healing?: number;
}

export enum DashboardView {
  biological = "biological",
  operational = "operational",
  fishGroups = "fishGroups",
}

/**
 *
 * Daypart tag the swim speed measurement belongs to, or null when unknown
 */

export enum DaypartTag {
  day = "day",
  night = "night",
  all = "all",
}

export interface DaysWithImages {
  count: number;
  day: string;
}

export interface DeleteUserResponse {
  id: number;
}

export interface DepthPointDto {
  /**
   *
   * Site wall clock with no zone. A day is YYYY-MM-DD; an hour is YYYY-MM-DD HH:mm:ss.
   * @example
   *   2024-01-16 14:00:00
   */
  time: string;
  /**
   *
   * Average depth in metres. Null is an hour or day with no reading.
   * @example
   *   35.4
   */
  value?: number;
}

export interface DepthSeriesResponseDto {
  cages: CageDepthSeriesDto[];
}

export interface DestinationInflowDto {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  sourceFishGroupId: number;
  /**
   *
   * - minimum: 1
   */
  estimatedFishCount?: number;
}

export interface DiscardFishGroupRequest {
  reason: DiscardReason;
  notes?: string;
}

export enum DiscardReason {
  operator_error = "operator_error",
  wrong_cage = "wrong_cage",
  duplicate = "duplicate",
  other = "other",
}

export interface DistributionResultData {
  cv: number;
  dailyDistributionTypeTag: string;
  kurtosis: number;
  skewness: number;
  weight: number;
}

export interface EmqxAclRule {
  action: "publish" | "subscribe" | "all";
  permission: "allow" | "deny";
  topic: string;
}

export interface EmqxJwtPayloadDto {
  /**
   *
   * Access Control List - defines publish/subscribe permissions
   */
  acl?: EmqxAclRule[];
  /**
   *
   * Client attributes - custom metadata
   */
  clientAttrs?: { [x in string | number]: any };
  /**
   *
   * MQTT client ID - alternative to username
   */
  clientId?: string;
  /**
   *
   * Token expiration
   */
  expiresIn?: { [x in string | number]: any };
  /**
   *
   * MQTT username - used for client identification
   */
  username?: string;
}

export interface EnvironmentalBlockDto {
  /**
   *
   * The site's wall-clock time of the last measurement in the hourly bucket, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when unknown.
   * @example
   *   2026-08-26T10:00:00
   */
  lastMeasurement: string;
  /**
   *
   * Average depth over the hourly bucket, metres.
   */
  depth?: number;
  /**
   *
   * Oxygen concentration, mg/L. Null when the sensor did not report a value.
   */
  oxygenConcentration?: number;
  /**
   *
   * Oxygen saturation, percent. Null when the sensor did not report a value.
   */
  oxygenSaturation?: number;
  /**
   *
   * Salinity, PSU. Null when the cage has no salinity sensor.
   */
  salinity?: number;
  /**
   *
   * Water temperature, °C. Null when the sensor did not report a value.
   */
  temperature?: number;
}

export interface EnvironmentalFactorsDto {
  /**
   *
   * The site's wall-clock time of the last measurement, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when unknown.
   * @example
   *   2024-01-15T14:30:00
   */
  lastMeasurement: string;
  /**
   *
   * Depth in meters
   * @example
   *   10.2
   */
  depth?: number;
  /**
   *
   * Oxygen concentration in mg/L
   * @example
   *   8.2
   */
  oxygenConcentration?: number;
  /**
   *
   * Oxygen saturation in %
   * @example
   *   91
   */
  oxygenSaturation?: number;
  /**
   *
   * Salinity in PSU (Practical Salinity Units)
   * @example
   *   33.2
   */
  salinity?: number;
  /**
   *
   * Temperature in Celsius
   * @example
   *   8.5
   */
  temperature?: number;
}

export interface FeedingConversionRateDays {
  bias_kf: number;
  biomass: number;
  day: string;
  fcr: number;
  fcr_acc: number;
  feed_amount: number;
  feed_per_fish: number;
  fish_count: number;
  growth_kf: number;
  weight_kf: number;
  weight_meas: number;
  fcr_pms?: number;
  /**
   *
   * PMS plan and actual signals. Null on a day whose provider mapping omits them.
   */
  feed_planned?: number;
  weight_pms_actual?: number;
  weight_pms_plan?: number;
}

export interface FeedingConversionRateResult {
  cage: string;
  client: string;
  day_from: string;
  day_to: string;
  days: FeedingConversionRateDays[];
  location: string;
  /**
 * 
 * Whether a live feeding refresh is running for this cage, per this API process.
Always false when FEEDING_LIVE_REFRESH_ENABLED is false, since nothing is ever
triggered, and false while the cage is sitting out its post-attempt cooldown.
 */
  refreshing: boolean;
  /**
 * 
 * Newest fetched_at (ISO 8601) among this cage's stored feeding rows in the
resolved window. Null when the live refresh is disabled, the resolved window has
no live-fetchable part, this cage has no provider config, or nothing has been
fetched yet.
 */
  lastFetchedAt?: string;
}

export interface FeedingDashboardConfigDto {
  /**
   *
   * Distinct Bioscope measurement days a pen needs before its estimates count as reliable (IPS req 7). Default 21; the IPS leaves "sufficient data" undefined.
   * - minimum: 1
   * - max: 120
   * @example
   *   21
   */
  bioscopeReadyDays: number;
  /**
   *
   * bFCR interval band: an interval up to pct of the bFCR value is unmarked. Information only, never a warning.
   * @example
   *   25
   */
  confIntervalGoodPct: number;
  /**
   *
   * bFCR interval band: up to pct of the bFCR value is the light mark, wider is the strong mark. Information only, never a warning.
   * @example
   *   40
   */
  confIntervalWarnPct: number;
  /**
   *
   * Fallthrough red threshold (%): above this is red.
   * @example
   *   10
   */
  fallthroughAlertPct: number;
  /**
   *
   * Camera depth (m) at or below which detected pellets count as fallthrough (IPS req 23).
   * @example
   *   10
   */
  fallthroughDepthThresholdM: number;
  /**
   *
   * Fallthrough yellow threshold (%): at/above this is yellow.
   * @example
   *   8
   */
  fallthroughWarnPct: number;
  /**
   *
   * FCR bio target. Reference line in the FCR graph and the green/yellow boundary (IPS req 12).
   * @example
   *   1.12
   */
  fcrTarget: number;
  /**
   *
   * FCR caution margin (%) above target: yellow up to target×(1+pct/100), red beyond.
   * @example
   *   5
   */
  fcrWarnPct: number;
  /**
   *
   * Deprecated. Feed vs plan is coloured by sign per the Pen Comparison spec (fed more than plan = green, less = red), not by magnitude bands.
   * @example
   *   5
   */
  feedVsPlanGoodPct: number;
  /**
   *
   * Deprecated. See feedVsPlanGoodPct.
   * @example
   *   15
   */
  feedVsPlanWarnPct: number;
  /**
   *
   * RGI target. Reference line in the RGI graph and the green/yellow boundary.
   * @example
   *   100
   */
  rgiTarget: number;
  /**
   *
   * RGI caution margin (%) below target: yellow down to target×(1−pct/100), red below.
   * @example
   *   10
   */
  rgiWarnPct: number;
  /**
   *
   * Upper bound of the healthy SFR range (%). Default 2.0, per the same spec.
   * @example
   *   2
   */
  sfrHealthyMaxPct: number;
  /**
   *
   * Lower bound of the healthy SFR range (%). Below this the SFR cell shows caution. Default 1.0, per the Pen Comparison spec ("Healthy range for salmon: 1-2%").
   * @example
   *   1
   */
  sfrHealthyMinPct: number;
  /**
   *
   * SFR (%) above which overfeeding is likely and the cell shows alert. Default 3.0, per the spec ("above ~3% may mean overfeeding").
   * @example
   *   3
   */
  sfrOverfeedPct: number;
  /**
   *
   * Period length (days) above which every period-derived figure buckets weekly instead of daily: both time charts, the pellet KPI and the pellet column (IPS req 4). Default 60, so up to two months stays daily.
   * - minimum: 7
   * - max: 365
   * @example
   *   31
   */
  weeklyResolutionDays: number;
  /**
   *
   * Deprecated. Weight deviation band, retained for compatibility. The Pen Comparison spec has no Bioscope-vs-PMS deviation column, so nothing reads this.
   * @example
   *   5
   */
  weightDevGoodPct: number;
  /**
   *
   * Deprecated. See weightDevGoodPct.
   * @example
   *   10
   */
  weightDevWarnPct: number;
  /**
   *
   * The customer's production-planning system, shown wherever a label would otherwise read generically (IPS req 28), e.g. 'Fishtalk' or 'Mercatus'. Null renders the generic wording. Stored per site rather than derived from the provider name, which identifies the integration (Clarify) and not the planning tool behind it (Mercatus).
   * @example
   *   Mercatus
   */
  pmsSystemName?: string;
}

export interface FeedingDashboardController_getOverviewQueryParams {
  /**
   *
   * Pen (cage) ids to include, comma-separated or repeated. Empty = every pen at the location with a Bioscope assignment, a Bioscope estimate or planning-system data in the period. Ids outside that set are ignored.
   */
  cageIds?: number[];
  /**
   *
   * Period start (YYYY-MM-DD). Omit for "show all": the period then starts at the earliest day any selected pen has data (capped at 3 years), or 27 days before `to` when there is none. A start after today at the site is clamped to that day.
   */
  from?: string;
  /**
   *
   * Include pellet fallthrough. Omitted or false skips every pellet read: pens report `fallthroughSupported: false`, `dataSources.pellet` is `notConfigured`, the pellet summary values are null or empty, and `fallthroughDaily` is empty.
   */
  includeFallthrough?: boolean;
  /**
   *
   * Period end (YYYY-MM-DD), inclusive. Defaults to the site's today, and a later date is clamped to it.
   */
  to?: string;
}

export interface FeedingDashboardOverviewDto {
  /**
   *
   * Every pen at the site with a Bioscope assignment, a Bioscope estimate or planning-system data in the period, whatever `cageIds` asks for.
   */
  availablePens: FeedingPenOptionDto[];
  config: FeedingDashboardConfigDto;
  /**
   *
   * Per-source availability across the selected pens, so the UI can distinguish missing from unmapped. A source counts as configured when ANY selected pen maps it, matching the aggregate charts: if one pen has data, the aggregate legitimately has data. Per-pen state lives on each entry in `pens` and covers `from` to `closingDay`; this site-wide state reads the rows `feedWeightSeries` draws, `from` to `to`.
   */
  dataSources: FeedingDataSourcesDto;
  /**
   *
   * Pellet fallthrough per bucket at `resolution` over `from` to `to`, including the bucket of siteToday when the period includes it. `summary.fallthroughAvgPct` is the mean of the buckets up to `closingDay`. Empty when the request did not set `includeFallthrough`.
   */
  fallthroughDaily: FeedingFallthroughDayDto[];
  /**
   *
   * Where each environmental overlay in `feedWeightSeries` came from, so the chart can name the planning system wherever it supplied the values.
   */
  feedWeightOverlaySources: FeedingOverlaySourcesDto;
  /**
   *
   * Feed and weight per bucket at `resolution` over `from` to `to`. When the period includes siteToday its bucket is included and holds only what has arrived so far, typically the plan; a value that has not arrived is null, never zero.
   */
  feedWeightSeries: FeedingSeriesPointDto[];
  /**
   *
   * Live feeding refresh status for the pens in this response.
   */
  feeding: FeedingRefreshStatusDto;
  /**
   *
   * Resolved period start (YYYY-MM-DD).
   */
  from: string;
  locationId: number;
  /**
   *
   * The selected pens: `cageIds` narrowed to `availablePens`, or all of them. Empty when the period has no pens or none of the requested ones is among them.
   */
  pens: FeedingPenDto[];
  /**
   *
   * Series granularity (IPS req 4).
   */
  resolution: "day" | "week";
  /**
   *
   * The site's calendar date now (YYYY-MM-DD), from the location's timezone. The day in progress: no summary or pen value covers it, and both series include its bucket whenever the period does, for the client to mark as in progress.
   */
  siteToday: string;
  summary: FeedingSummaryDto;
  /**
   *
   * Resolved period end (YYYY-MM-DD): the requested `to`, or the site's today when none was given, and never after the site's today.
   */
  to: string;
  /**
   *
   * The last complete site day of the period, min(to, siteToday - 1). Closing-day metrics (fish count, weights, bFCR, RGI and both intervals, IPS 37) are read on this day exactly and are null when it has no data; values are never carried forward from an earlier day. The summary and every pen value cover `from` to this day; the Feed & Weight series and the pellet series cover `from` to `to`. Null when the period contains no complete day, in which case every summary and pen value is null and the series hold only today.
   */
  closingDay?: string;
}

export interface FeedingDataSourcesDto {
  /**
   *
   * Bioscope environmental sensors (temperature, oxygen, salinity).
   */
  environment: "live" | "noData" | "notConfigured";
  /**
   *
   * FCR reported by the PMS itself.
   */
  fcrPms: "live" | "noData" | "notConfigured";
  /**
   *
   * Feed actual (PMS).
   */
  feedActual: "live" | "noData" | "notConfigured";
  /**
   *
   * Feed plan (PMS).
   */
  feedPlan: "live" | "noData" | "notConfigured";
  /**
   *
   * Fish count (PMS), the standing-biomass denominator for SFR.
   */
  fishCount: "live" | "noData" | "notConfigured";
  /**
   *
   * Pellet fallthrough. notConfigured when no pen has Bioscope 3.0 hardware, or when the request did not set `includeFallthrough`; noData when no pellet with a winch depth arrived on the days this state covers, since fallthrough needs depth data (IPS 3.1.2). A pen's state covers the complete days of the period (`from` to `closingDay`), the days its pellet value covers; the site-wide state covers `from` to `to`, the days the pellet timeline draws.
   */
  pellet: "live" | "noData" | "notConfigured";
  /**
   *
   * Bioscope weight measurements.
   */
  weightBioscope: "live" | "noData" | "notConfigured";
  /**
   *
   * Weight FT/merc actual (PMS).
   */
  weightPmsActual: "live" | "noData" | "notConfigured";
  /**
   *
   * Weight FT/merc plan (PMS).
   */
  weightPmsPlan: "live" | "noData" | "notConfigured";
}

export interface FeedingFallthroughDayDto {
  /**
   *
   * Bucket start (YYYY-MM-DD), at the same `resolution` as `feedWeightSeries`: a day, or the Monday of an ISO week. Days are the site's local calendar days (`locations.timezone`), so an hour belongs to the day it fell on at the site. The series runs `from` to `to`, today included; `fallthroughAvgPct` is the mean of the same buckets over the complete days only.
   */
  day: string;
  /**
   *
   * Pellet fallthrough (%) over the bucket, from the pens with a winch depth in it. Null when the bucket has no pellets, or none with a winch depth: never a 0 % bar for a camera that measured no depth.
   */
  fallthroughPct?: number;
  /**
   *
   * Dominant operator on duty that day.
   */
  operatorId?: number;
  operatorName?: string;
}

export interface FeedingFeedCoverageDto {
  /**
   *
   * Pen-days with a Feed actual value.
   */
  actualDays: number;
  /**
   *
   * Pen-days in from..closingDay over the selected pens.
   */
  days: number;
  /**
   *
   * Number of selected pens.
   */
  pens: number;
  /**
   *
   * Selected pens with at least one Feed plan day in the period.
   */
  pensWithPlan: number;
  /**
   *
   * Pen-days with a Feed plan value.
   */
  planDays: number;
}

export interface FeedingOperatorFallthroughDto {
  operatorId: number;
  operatorName: string;
  /**
   *
   * Pellet fallthrough (%) over this operator’s shifts on the complete days of the period, leaving out the pens with no winch depth in a bucket, as the KPI does. Null when none of those pellets has a winch depth.
   */
  fallthroughPct?: number;
}

export interface FeedingOverlaySourcesDto {
  /**
   *
   * Source of `oxygenMgL`. Bioscope sensors only: the planning system reports no concentration. Null when no pen has a value.
   */
  oxygenMgL?: "bioscope" | "planningSystem" | "mixed";
  /**
   *
   * Source of `oxygenSaturationPct`. 'bioscope' when every value came from the Bioscope sensors, 'planningSystem' when every value came from the planning system, 'mixed' when some days or pens came from each. Null when no pen has a value.
   */
  oxygenSaturationPct?: "bioscope" | "planningSystem" | "mixed";
  /**
   *
   * Source of `salinityPpt`. Bioscope sensors only: the planning system reports no salinity. Null when no pen has a value.
   */
  salinityPpt?: "bioscope" | "planningSystem" | "mixed";
  /**
   *
   * Source of `temperatureC`. 'bioscope' when every value came from the Bioscope (its sensors, else its daily water temperature), 'planningSystem' when every value came from the planning system, 'mixed' when some days or pens came from each. Null when no pen has a value.
   */
  temperatureC?: "bioscope" | "planningSystem" | "mixed";
}

export interface FeedingPenDto {
  /**
   *
   * ready: an estimate in the period and at least bioscopeReadyDays distinct estimate days up to the closing day; collecting: an estimate in the period but fewer days; noData: no estimate in the period (bioscopeInPeriod says whether the pen had a Bioscope at all).
   */
  bioscopeDataQuality: "ready" | "collecting" | "noData";
  /**
   *
   * Whether a Bioscope was assigned to the pen, or produced an estimate for it, during the period. False for a pen listed only for its planning-system data, whose Bioscope values are then blank by definition.
   */
  bioscopeInPeriod: boolean;
  cageId: number;
  cageName: string;
  /**
   *
   * This pen's RESOLVED thresholds: the site config with the pen's own overrides applied. Pens on one site sit at different points in the cycle, so a single FCR or SFR target would flag a healthy pen or excuse a struggling one. Site-level surfaces (KPI cards, the single target line on the bar charts) keep using the site config, since an aggregate has no one pen's target.
   */
  config: FeedingDashboardConfigDto;
  /**
   *
   * Per-source availability for THIS pen, from its own provider mapping. Pens on the same site can differ mid-onboarding, so a blank cell is only explained by the pen's own state, not the site-wide one.
   */
  dataSources: FeedingDataSourcesDto;
  /**
   *
   * Whether this pen has pellets with a winch depth on the complete days of the period, which is what `fallthroughPct` needs.
   */
  fallthroughAvailable: boolean;
  /**
   *
   * Whether pellet fallthrough was requested (`includeFallthrough`) and this pen has Bioscope 3.0 hardware (IPS req 27). Always false without `includeFallthrough`.
   */
  fallthroughSupported: boolean;
  /**
   *
   * How many days in from..closingDay this pen has a Feed actual and a Feed plan.
   */
  feedCoverage: FeedingPenFeedCoverageDto;
  /**
   *
   * Whether service-feeding-rest failed to answer for this pen. Its planning-system values, bFCR bioscope and Kalman trend are then missing, and its `dataSources` read as if no data had arrived; this flag is what says the service was the cause.
   */
  feedingServiceUnavailable: boolean;
  /**
   *
   * Pellet fallthrough (%): the unweighted mean of this pen's bucket percentages over the complete days of the period (`from` to `closingDay`), at the period `resolution`, each bucket judged against the depth threshold of the pen the Bioscope served at the time. Null when none of its pellets has a winch depth.
   */
  fallthroughPct?: number;
  /**
   *
   * Bioscope FCR over the fixed 7-day window, rounded half-up to 2 dp and compared with the target as rounded, like fcrPms.
   */
  fcrBioscope?: number;
  /**
   *
   * 95% confidence half-interval (3 dp) on this pen's fcrBioscope, as service-feeding-rest reports it (fcr_conf_interval) for the same window on the closing day. Null when the service withholds it, and with fcrBioscope when no measurement backs the window.
   */
  fcrBioscopeConfInterval?: number;
  /**
   *
   * FCR reported by the PMS itself, rounded half-up to 2 dp. The warning state compares this rounded value with the target, so a true 1.124 shows as 1.12 and does not warn against 1.12.
   */
  fcrPms?: number;
  feedVsPlanPct?: number;
  /**
   *
   * Fish count from the planning system on the closing day (IPS 23, 37). Null when that day has no count; never carried forward.
   */
  fishCount?: number;
  /**
   *
   * Date (YYYY-MM-DD) the pen was marked historical, or null.
   */
  historicalSince?: string;
  /**
   *
   * RGI (Bioscope) = Weight BS / Weight FT/merc plan × 100 on the closing day, floored to 1 dp like rgiFeed.
   */
  rgiBioscope?: number;
  /**
   *
   * RGI (feed-based) = Weight FT/merc actual / Weight FT/merc plan × 100 on the closing day, floored to 1 dp so a value shown below the target is below it in fact (IPS 2.2.3, 2.6.2).
   */
  rgiFeed?: number;
  /**
   *
   * SFR Bioscope (utfôringsprosent), %.
   */
  sfrBioscopePct?: number;
  /**
   *
   * SFR PMS (utfôringsprosent), %: average daily feed actual / (Weight FT/merc actual × fish count), both on the closing day (IPS 35). A biomass the provider reports is not used.
   */
  sfrPmsPct?: number;
  /**
   *
   * 95% confidence half-interval (g) of the closing day's Bioscope estimate (IPS req 11, table column "Conf. int. (Weight BS)"), from daily_estimate.conf_weight. It describes the day's estimate, not the Kalman trend that weightBioscopeG shows on a ready pen. Null when that day has no estimate or the estimate has no interval.
   */
  weightBioscopeConfIntervalG?: number;
  /**
   *
   * Weight BS (g) on the closing day (IPS 9, 37): on a ready pen the Kalman trend, shown only when that day has a Bioscope estimate behind it; otherwise the day's estimate. Null when the closing day has no estimate.
   */
  weightBioscopeG?: number;
  /**
   *
   * Weight FT/merc actual (g), last day of period.
   */
  weightPmsActualG?: number;
  /**
   *
   * Weight FT/merc plan (g), last day of period.
   */
  weightPmsPlanG?: number;
}

export interface FeedingPenFeedCoverageDto {
  /**
   *
   * Days in from..closingDay with a Feed actual value.
   */
  actualDays: number;
  /**
   *
   * Days in from..closingDay; 0 when the period has no complete day.
   */
  days: number;
  /**
   *
   * Days in from..closingDay with a Feed plan value.
   */
  planDays: number;
}

export interface FeedingPenOptionDto {
  /**
   *
   * Whether a Bioscope was assigned to the pen, or produced an estimate for it, during the period. False for a pen listed only for its planning-system data.
   */
  bioscopeInPeriod: boolean;
  cageId: number;
  cageName: string;
  /**
   *
   * Whether a Bioscope is assigned to the pen right now.
   */
  currentBioscope: boolean;
  /**
   *
   * Date (YYYY-MM-DD) the pen was marked historical, or null. A label only: a pen with data in the period is listed whatever its status.
   */
  historicalSince?: string;
}

export interface FeedingPenQualityDto {
  /**
   *
   * Pens with Bioscope data in the period, still in startup.
   */
  collecting: number;
  /**
   *
   * Pens listed for their planning-system data only (bioscopeInPeriod false).
   */
  noBioscope: number;
  /**
   *
   * Pens with a Bioscope in the period that produced no estimate in it.
   */
  noData: number;
  /**
   *
   * Pens whose Bioscope values count (bioscopeDataQuality ready).
   */
  ready: number;
}

export interface FeedingRefreshStatusDto {
  /**
   *
   * Whether a live feeding refresh is running for these pens, per this API process. Always false when FEEDING_LIVE_REFRESH_ENABLED is false, and false while a stale pen is sitting out its post-attempt cooldown.
   */
  refreshing: boolean;
  /**
   *
   * Pens whose stored feeding data was stale for this request. Always empty while FEEDING_LIVE_REFRESH_ENABLED is false.
   */
  staleCageIds: number[];
  /**
   *
   * Newest fetched_at (ISO 8601) among the requested pens in the resolved window. Null when the live refresh is disabled, the resolved window has no live-fetchable part, no requested pen has a provider config, or nothing has been fetched yet.
   */
  lastFetchedAt?: string;
}

export interface FeedingSeriesPointDto {
  /**
   *
   * Bucket start date (YYYY-MM-DD).
   */
  bucket: string;
  feedActualKg?: number;
  feedPlannedKg?: number;
  /**
   *
   * Oxygen concentration (mg/L), Bioscope sensors only.
   */
  oxygenMgL?: number;
  /**
   *
   * Oxygen saturation (%). A distinct quantity from the concentration above, not a unit conversion. Each pen is filled per day: its Bioscope sensors on a day they have a reading, else the planning system.
   */
  oxygenSaturationPct?: number;
  /**
   *
   * Salinity (‰), Bioscope sensors only.
   */
  salinityPpt?: number;
  /**
   *
   * Water temperature (°C), mean over pens. Each pen is filled per day: its Bioscope sensors on a day they have a reading, else the Bioscope's daily water temperature, else the planning system. See `feedWeightOverlaySources`.
   */
  temperatureC?: number;
  /**
   *
   * Mean daily Bioscope estimate (g) over the selected pens that are still collecting (fewer than `bioscopeReadyDays` estimate days). Plotted as points, apart from the line.
   */
  weightBioscopeCollectingG?: number;
  /**
   *
   * Weight bioscope line (g): mean over the selected pens whose Bioscope data is ready, each pen's Kalman trend where the service returned one and its daily estimate otherwise, and nothing after the pen's last estimate day. Weekly buckets are a mean over pen-days.
   */
  weightBioscopeG?: number;
  /**
   *
   * Deprecated, remove after one release: read `weightBioscopeG` and `weightBioscopeCollectingG`. Kept so a frontend loaded before the deploy still draws its chart. Mean daily Bioscope estimate (g) over every selected pen with one, ready or still collecting.
   */
  weightBioscopeMeasG?: number;
  /**
   *
   * Deprecated, remove after one release: read `weightBioscopeG`. Kept so a frontend loaded before the deploy still draws its chart. Mean Kalman trend (g) over every selected pen with an estimate in the period, ready or still collecting, each cut after the pen's last estimate day.
   */
  weightBioscopeTrendG?: number;
  /**
   *
   * Mean Weight FT/merc actual (g).
   */
  weightPmsActualG?: number;
  /**
   *
   * Mean Weight FT/merc plan (g).
   */
  weightPmsPlanG?: number;
}

export interface FeedingSummaryCoverageDto {
  /**
   *
   * Pens with pellets with a winch depth on the complete days of the period (`from` to `closingDay`), whatever their weight readiness.
   */
  fallthrough: number[];
  /**
   *
   * Ready pens with a bFCR bioscope.
   */
  fcrBioscope: number[];
  /**
   *
   * Pens with a planning-system bFCR on the closing day.
   */
  fcrPms: number[];
  /**
   *
   * Pens with at least one Feed actual day in the period.
   */
  feedActual: number[];
  /**
   *
   * Pens with at least one Feed plan day in the period.
   */
  feedPlan: number[];
  /**
   *
   * Ready pens with both Weight BS and Weight plan on the closing day.
   */
  rgiBioscope: number[];
  /**
   *
   * Pens with both Weight actual and Weight plan on the closing day.
   */
  rgiFeed: number[];
  /**
   *
   * Number of pens in the response, i.e. the selected pens.
   */
  selectedPens: number;
  /**
   *
   * Ready pens with a Weight BS on the closing day.
   */
  weightBioscope: number[];
  /**
   *
   * Pens with a Weight actual on the closing day.
   */
  weightPmsActual: number[];
  /**
   *
   * Pens with a Weight plan on the closing day.
   */
  weightPmsPlan: number[];
}

export interface FeedingSummaryDto {
  /**
   *
   * The best selected pen: ready when any pen is ready, since the Bioscope values come from ready pens only; collecting when none is ready but one is collecting; otherwise noData. penQuality has the counts.
   */
  bioscopeDataQuality: "ready" | "collecting" | "noData";
  /**
   *
   * The pens each value was computed from.
   */
  coverage: FeedingSummaryCoverageDto;
  /**
   *
   * Whether any pen has pellets with a winch depth on the complete days of the period (`from` to `closingDay`), which is what a fallthrough value needs.
   */
  fallthroughAvailable: boolean;
  /**
   *
   * Pellet fallthrough split by operator on duty. OptoScale extension, not part of the IPS.
   */
  fallthroughByOperator: FeedingOperatorFallthroughDto[];
  /**
   *
   * Whether pellet fallthrough was requested (`includeFallthrough`) and any selected pen has Bioscope 3.0 hardware, which is what pellet fallthrough requires (IPS req 27). Always false without `includeFallthrough`.
   */
  fallthroughSupported: boolean;
  /**
   *
   * How many pen-days the feed totals and Feed vs plan rest on.
   */
  feedCoverage: FeedingFeedCoverageDto;
  /**
   *
   * How many selected pens are in each Bioscope state.
   */
  penQuality: FeedingPenQualityDto;
  /**
   *
   * 95% confidence half-interval (g) of the mean of the contributing pens' closing-day Bioscope estimates: sqrt(sum of the pen half-intervals squared) / pens, from daily_estimate.conf_weight (IPS req 11). It describes the day's estimates, not the Kalman trend that avgWeightBioscopeG averages for ready pens. Null unless every contributing pen has one.
   */
  avgWeightBioscopeConfIntervalG?: number;
  /**
   *
   * Mean Weight BS (g) on the closing day over the ready pens that have one (coverage.weightBioscope).
   */
  avgWeightBioscopeG?: number;
  /**
   *
   * Mean Weight FT/merc actual (g) on the closing day over the pens that have one.
   */
  avgWeightPmsActualG?: number;
  /**
   *
   * Mean Weight FT/merc plan (g) on the closing day over the pens that have one.
   */
  avgWeightPmsPlanG?: number;
  /**
   *
   * Average pellet fallthrough (%): the unweighted mean of the site-wide bucket percentages over the complete days of the period (`from` to `closingDay`), at the period `resolution`. A pen with no winch depth in a bucket adds none of its pellets to it, and a bucket whose pellets have no winch depth at all has no percentage and is skipped. Null when no bucket has one.
   */
  fallthroughAvgPct?: number;
  /**
   *
   * Bioscope FCR: a 7-day rolling feed sum over Bioscope-anchored Kalman growth, as of the last day of the period, averaged over the ready pens that have one before rounding half-up to 2 dp. The window is fixed at 7 days in run_kalman; there is no setting for it. The growth term is smoothed over the whole archived window, so this is not a self-contained 7-day statistic.
   */
  fcrBioscope?: number;
  /**
   *
   * 95% confidence half-interval of the mean Bioscope FCR: sqrt(sum of the pen half-intervals squared) / pens. Each pen interval comes from the exact Kalman posterior variance of the window growth (IPS req 11), statistical within the model and conditional on the reported fish count. Null unless every contributing pen has one.
   */
  fcrBioscopeConfInterval?: number;
  /**
   *
   * FCR reported by the PMS itself (cage_feeding_ext_api.fcr_pms), last day of period. Null when the PMS does not provide one.
   */
  fcrPms?: number;
  /**
   *
   * Total feed dispensed in the period (kg).
   */
  feedActualKg?: number;
  /**
   *
   * Total planned feed in the period (kg).
   */
  feedPlannedKg?: number;
  /**
   *
   * Feed vs plan deviation (%), actual/plan - 1.
   */
  feedVsPlanPct?: number;
  /**
   *
   * RGI (Bioscope) = 100 × mean Weight BS / mean Weight FT/merc plan over the ready pens that have both on the closing day, from unrounded weights, floored to 1 dp.
   */
  rgiBioscope?: number;
  /**
   *
   * RGI (feed-based) = 100 × mean Weight FT/merc actual / mean Weight FT/merc plan over the pens that have both on the closing day, from unrounded weights, floored to 1 dp.
   */
  rgiFeed?: number;
  /**
   *
   * SFR Bioscope (%): same as SFR PMS but using Weight BS.
   */
  sfrBioscopePct?: number;
  /**
   *
   * SFR PMS (%): average daily feed over the period / standing biomass from Weight FT/merc actual.
   */
  sfrPmsPct?: number;
}

export interface FetchHistoryRequestDto {
  /**
   *
   * First UTC day, YYYY-MM-DD.
   * - pattern: DAY_RE
   * @example
   *   2026-06-01
   */
  from: string;
  /**
   *
   * Last UTC day, YYYY-MM-DD; not after today (UTC).
   * - pattern: DAY_RE
   * @example
   *   2026-06-30
   */
  to: string;
}

export interface FetchHistoryResultDto {
  /**
   * @example
   *   101
   */
  cageId: number;
  /**
   *
   * Days in the window with at least one stored value.
   */
  daysWithData: number;
  /**
   *
   * Days whose write failed, YYYY-MM-DD.
   */
  failedDays: string[];
  /**
   * @example
   *   2026-06-01
   */
  from: string;
  /**
   *
   * True when only a provider without population data answered; nothing was written.
   */
  partialOnly: boolean;
  /**
   *
   * Providers tried and passed over.
   */
  skipped: SkippedProviderDto[];
  /**
   * @example
   *   2026-06-30
   */
  to: string;
  /**
   *
   * Days written to the feeding table.
   */
  written: number;
  /**
   *
   * The provider whose data was written; null when none had population data.
   */
  providerName?: string;
}

export interface FieldPatchDto {
  /**
   *
   * A schema field key, e.g. `base_url` or `signal_mappings.biomass`.
   * - maxLength: 255
   */
  key: string;
  list?: string[];
  /**
   *
   * - maxLength: 60000
   */
  text?: string;
}

export interface FieldValueDto {
  key: string;
  /**
   *
   * Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  list?: string[];
  /**
   *
   * Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  text?: string;
}

export interface FishGroupCurrentLocationDto {
  cageId: number;
  cageName: string;
  /**
   *
   * - Format: date-time
   */
  fromDate: string;
  locationId: number;
  locationName: string;
  locationRowId: number;
}

export interface FishGroupDetailDto {
  clientId: number;
  fishTypeId: number;
  id: number;
  name: string;
  status: "pending" | "active" | "closed" | "harvested" | "merged" | "split";
  currentLocation?: FishGroupCurrentLocationDto;
  initialPopulationSize?: number;
  /**
   *
   * - Format: date-time
   */
  lifecycleEndedAt?: string;
  /**
   *
   * - Format: date-time
   */
  lifecycleStartedAt?: string;
  notes?: string;
  /**
   *
   * The stocking cycle the group belongs to, or null when unassigned. Results of a split, merge, split-and-merge or redistribution inherit it from their sources.
   */
  stockingCycleId?: number;
}

export interface FishGroupDto {
  clientId: number;
  fishTypeId: number;
  id: number;
  name: string;
  status: "pending" | "active" | "closed" | "harvested" | "merged" | "split";
  initialPopulationSize?: number;
  /**
   *
   * - Format: date-time
   */
  lifecycleEndedAt?: string;
  /**
   *
   * - Format: date-time
   */
  lifecycleStartedAt?: string;
  notes?: string;
  /**
   *
   * The stocking cycle the group belongs to, or null when unassigned. Results of a split, merge, split-and-merge or redistribution inherit it from their sources.
   */
  stockingCycleId?: number;
}

export interface FishGroupLineageDto {
  flat: LineageFlatDto;
  graph: LineageGraphDto;
  rootId: number;
}

export interface FishGroupLocationHistoryItemDto {
  cageId: number;
  cageName: string;
  /**
   *
   * - Format: date-time
   */
  fromDate: string;
  id: number;
  locationId: number;
  locationName: string;
  reason?: string;
  /**
   *
   * - Format: date-time
   */
  toDate?: string;
}

export interface FishGroupOperationRequest {
  destinations: OperationDestinationDto[];
  sources: OperationSourceDto[];
  /**
   *
   * Optional bioscope moves to perform atomically with the operation. Each item moves a single bioscope into the cage referenced by `targetCageId`. When omitted or empty the endpoint behaves exactly as before.
   */
  bioscopeMovements?: BioscopeMovementDto[];
  notes?: string;
  /**
   *
   * When the operation happened. Defaults to the current server time. Must be ISO 8601.
   */
  operationDate?: string;
  reason?: string;
}

export interface FishGroupOperationSummaryDto {
  id: number;
  /**
   *
   * - Format: date-time
   */
  operationDate: string;
  operationType:
    | "creation"
    | "relocation"
    | "split"
    | "merge"
    | "split_and_merge"
    | "redistribution"
    | "closure"
    | "discard"
    | "revert";
  operatorId: number;
  notes?: string;
  reason?: string;
  /**
   *
   * The revert operation that annulled this operation, or null.
   */
  revertedByOperationId?: number;
  /**
   *
   * For a revert operation, the operation it annulled; null otherwise.
   */
  revertsOperationId?: number;
}

export interface FishGroupTimelineDto {
  /**
   *
   * Groups outside the scope at the far end of a listed transfer, so ones that took part in an operation at this site: the parent of an unassigned group in an earlier cycle, for example.
   */
  externalGroups: TimelineExternalGroupDto[];
  /**
   *
   * The clock the response used.
   * - Format: date-time
   */
  generatedAt: string;
  /**
   *
   * Every group in scope, active and closed; discarded groups are left out.
   */
  groups: TimelineFishGroupDto[];
  locationId: number;
  scope: TimelineScopeDto;
  /**
   *
   * Transfers that happened at this site (the source was in one of its pens on the transfer date) with at least one end in scope. Links through another site are only offSiteLinks on the group.
   */
  transfers: TimelineTransferDto[];
  /**
   *
   * The cycle header (status, stocking window, fallowing) for kind "cycle".
   */
  cycle?: StockingCycleDto;
}

export interface FishGroupTransferDto {
  destinationFishGroupId: number;
  id: number;
  /**
   *
   * ID of the composition-changing operation that produced this transfer. Same value across all transfers of one operation (split/merge/split_and_merge/redistribution).
   */
  operationId: number;
  /**
   *
   * Type of the composition-changing operation. Transfers only exist for DAG-creating operations, so creation/relocation/closure/discard are not present here.
   */
  operationType: "split" | "merge" | "split_and_merge" | "redistribution";
  sourceFishGroupId: number;
  /**
   *
   * - Format: date-time
   */
  transferDate: string;
  estimatedFishCount?: number;
  notes?: string;
  reason?: string;
  /**
   *
   * Id of the revert operation that annulled the operation behind this transfer, or null. A reverted transfer is kept for the record; its destination group was discarded.
   */
  revertedByOperationId?: number;
}

export interface FishGroupTransferEventDto {
  /**
   *
   * - Format: date-time
   */
  eventDate: string;
  eventType: string;
  fishGroupId: number;
  id: string;
  operatorId: number;
  cageId?: number;
  /**
   *
   * Event-specific metadata (JSON blob). For mortality: cause/details; for relocation: previous/new cageId; for split-and-merge destinations: inflows array; etc.
   */
  eventData?: { [x: string]: any };
  fishCountAfter?: number;
  fishCountBefore?: number;
  notes?: string;
  /**
   *
   * The composition-changing operation that produced this event. Null for manual events (mortality, harvest, measurement, feeding, treatment).
   */
  operation?: FishGroupOperationSummaryDto;
  operationId?: number;
}

export interface FishGroupsController_getEventsQueryParams {
  /**
   *
   * Filter events by type. Lifecycle: created/closed/relocated/discarded. Manual: mortality/harvest/measurement/feeding/treatment.
   */
  eventType?:
    | "created"
    | "closed"
    | "relocated"
    | "discarded"
    | "mortality"
    | "harvest"
    | "measurement"
    | "feeding"
    | "treatment"
    | "delousing"
    | "metadata_updated"
    | "reverted";
}

export interface FishType {
  id: number;
  is_default: boolean;
  name: string;
  shortName: string;
}

export interface FishTypeInfo {
  /**
   *
   * Fish type ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default fish type
   * @example
   *   true
   */
  is_default: boolean;
  /**
   *
   * Fish type name
   * @example
   *   Atlantic Salmon
   */
  name: string;
  /**
   *
   * Short name
   * @example
   *   AS
   */
  shortName: string;
}

export interface FullSizeImage {
  bboxes: FullSizeImageBoxes[];
  bioscopeId: number;
  height: number;
  id: string;
  path: string;
  /**
   *
   * - Format: date-time
   */
  timeStamp: string;
  width: number;
  /**
   *
   * - Format: date-time
   */
  day?: string;
  fishId?: number;
  indicators?: ImagesIndicatorResult;
}

export interface FullSizeImageBoxes {
  bbox: number[];
  score: number;
  tag: string;
  size_x_mm?: number;
  size_y_mm?: number;
}

export interface GetApiUsersResponse {
  accessLevel: number;
  allowedCageIds: number[];
  allowedLocationIds: number[];
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  lastUsed?: string;
}

export interface GetCageTypesResponse {
  /**
   *
   * List of available cage types
   */
  cageTypes: CageTypeDto[];
}

export interface GetWeightDistributionsResponse {
  weightDistributions: WeightDistributionData[];
}

export interface HealthAlertDto {
  level: "high" | "increasing" | "stable";
  priority: number;
  appliedThreshold?: number;
}

export interface HealthController_getHealthDataQueryParams {
  /**
   *
   * Daypart filter for welfare color estimates (day, night, or all).
   */
  daypartTag?: "day" | "night" | "all";
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Trend chart range start (YYYY-MM-DD). With `to`, only affects `parameters[].trend` and `charts.woundDailyTrend`.
   */
  from?: string;
  /**
   *
   * Trend chart range end (YYYY-MM-DD). Must be used with `from`.
   */
  to?: string;
}

export interface HealthController_getQualityQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface HealthDateWindowDto {
  /**
   * @example
   *   2026-04-14
   */
  from: string;
  /**
   * @example
   *   2026-04-20
   */
  to: string;
}

export interface HealthLastDayWelfareDto {
  acuteWoundsArea?: number;
  anyAcuteWound?: number;
  anyWound?: number;
  avgAcuteWoundSize?: number;
  avgWoundSize?: number;
  bigAcuteWound?: number;
  bigWound?: number;
  fullyMature?: number;
  halfWayMature?: number;
  maturity?: number;
  mediumAcuteWound?: number;
  mediumWound?: number;
  moreThanOneWound?: number;
  noWound?: number;
  notSuperior?: number;
  numHealingWounds?: number;
  numWounds?: number;
  oneWound?: number;
  scaleLoss?: number;
  smallAcuteWound?: number;
  smallWound?: number;
  startedMaturation?: number;
  woundsArea?: number;
}

export interface HealthOverviewChartsDto {
  woundDailyTrend: HealthWoundTrendPointDto[];
}

export interface HealthOverviewContextDto {
  /**
   *
   * Latest estimate day used for summary, weekly metrics, and alerts (always the newest row; not a query input).
   * @example
   *   2026-04-20
   */
  asOf: string;
  /**
   * @example
   *   all
   */
  daypartTag: "day" | "night" | "all";
  /**
   *
   * Inclusive window used for chart trend series (`from`/`to` query or default last 4 weeks).
   */
  trendWindow: HealthDateWindowDto;
  weeklyWindow: HealthDateWindowDto;
}

export interface HealthOverviewDto {
  cageId: number;
  charts: HealthOverviewChartsDto;
  context: HealthOverviewContextDto;
  summary: HealthOverviewSummaryDto;
}

export interface HealthOverviewSummaryDto {
  lastDayWelfare: HealthLastDayWelfareDto;
  parameters: HealthParameterDto[];
  /**
   *
   * Fish counted for body wounds on `context.asOf` (`wound_count`, from `laksvel_body_wounds_cnt`).
   */
  woundCount?: number;
  /**
   *
   * Weekly `any_wound` trend (0–1), from precomputed per-day `any_wound_slope` on the latest estimate (× 7). Matches legacy welfare `woundSlope`.
   */
  woundSlope?: number;
}

export interface HealthParameterDto {
  alert: HealthAlertDto;
  key:
    | "bodyWounds"
    | "snoutWounds"
    | "scaleLoss"
    | "skinBleeding"
    | "finDamage"
    | "emaciation"
    | "deformity"
    | "deformedJaw"
    | "gillLid"
    | "cataract"
    | "eyeDamage"
    | "maturity";
  /**
   *
   * Show Laksvel detections in the image viewer: the latest estimate share of score 2 + score 3 fish is above the parameter image threshold.
   */
  showImageViewer: boolean;
  trend: HealthTrendPointDto[];
  daily?: HealthScoreMetricsDto;
  weekly?: HealthScoreMetricsDto;
}

export interface HealthQualityResponseDto {
  /**
   *
   * Latest estimate day (`YYYY-MM-DD`) used for the downgrade estimate.
   * @example
   *   2026-04-20
   */
  day?: string;
  /**
   *
   * Estimated downgrade share (0–1) from `daily_welfare_color_estimates.not_superior`, or from `daily_welfare_bw` when no color estimate row exists. Null when the cage has no BIOMASS_WITH_QUALITY licence or no data.
   */
  downgradeRate?: number;
}

export interface HealthScoreMetricsDto {
  count?: number;
  index?: number;
  score0?: number;
  score1?: number;
  score2?: number;
  score3?: number;
  slope?: number;
}

export interface HealthTrendPointDto {
  /**
   * @example
   *   2026-01-15
   */
  day: string;
  /**
   *
   * Fish counted for this parameter on that day (`{dbPrefix}_cnt`).
   */
  count?: number;
  index?: number;
  score0?: number;
  score1?: number;
  score2?: number;
  score3?: number;
}

export interface HealthWoundDistributionTrendDto {
  moreThanOneWound?: number;
  oneWound?: number;
}

export interface HealthWoundSizeDistributionTrendDto {
  bigWound?: number;
  mediumWound?: number;
  smallWound?: number;
}

export interface HealthWoundTrendPointDto {
  /**
   * @example
   *   2026-01-15
   */
  day: string;
  distributionOfWounds: HealthWoundDistributionTrendDto;
  sizeDistribution: HealthWoundSizeDistributionTrendDto;
  woundTypes: HealthWoundTypesTrendDto;
  /**
   *
   * Estimated downgrade share (`not_superior`) for this day (`daily_welfare_color_estimates.not_superior`).
   */
  notSuperior?: number;
  /**
   *
   * Water temperature (`dailyMeasurements.temp`) for the same cage and day, always from the `day` daypart (`daypart_tag = day`).
   */
  temperature?: number;
  /**
   *
   * Fish counted for body wounds that day (`wound_count`, from `laksvel_body_wounds_cnt`).
   */
  woundCount?: number;
}

export interface HealthWoundTypesTrendDto {
  numHealingWounds?: number;
  numWounds?: number;
}

export interface HistoricalBioscope {
  bioscopeId: number;
  /**
   *
   * - Format: date-time
   */
  from: string;
  /**
   *
   * - Format: date-time
   */
  to: string;
}

export interface IgnoreTaskDto {
  ignoredPermanently?: boolean;
  /**
   *
   * - maxLength: 1000
   */
  ignoredReason?: string;
  ignoredUntil?: string;
}

export interface ImageFeedbackDto {
  /**
   *
   * Why the image is reported, e.g. false_lice; one path segment
   * - pattern: ^[A-Za-z0-9_-]{1,64}$
   */
  tag: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  bioscopeId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  /**
   *
   * - Format: date-time
   */
  createdAt?: string;
  imageMetadataDto?: ImageMetadataDto;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  reportingUserId?: number;
}

export interface ImageFeedbackReceiptDto {
  /**
   * @example
   *   200
   */
  status: number;
  tag: string;
  /**
   *
   * The signed-in user the report was filed under
   */
  userId?: number;
}

export interface ImageMetadataBoxDto {
  bbox: number[];
  score: number;
  /**
   *
   * - maxLength: 80
   */
  tag: string;
  size_x_mm?: number;
  size_y_mm?: number;
}

export interface ImageMetadataDto {
  /**
   *
   * - maxLength: 32
   */
  day: string;
  height: number;
  /**
   *
   * - maxLength: 64
   */
  id: string;
  /**
   *
   * - maxLength: 2048
   */
  path: string;
  /**
   *
   * - maxLength: 64
   */
  timeStamp: string;
  width: number;
  bboxes?: ImageMetadataBoxDto[];
  /**
   *
   * - maxLength: 2048
   */
  permalink?: string;
  /**
   *
   * - maxLength: 1024
   */
  scpCommand?: string;
}

export interface ImagesIndicatorResult {
  body_wounds_score?: number;
  cataract_score?: number;
  deformed_jaw_score?: number;
  deformity_score?: number;
  emaciation_score?: number;
  eye_damage_score?: number;
  fin_damage_score?: number;
  gill_lid_score?: number;
  maturity?: number;
  maturity_score?: number;
  scale_loss?: number;
  scale_loss_score?: number;
  snout_wounds_score?: number;
  wounds_class?: number;
}

export interface InviteForm {
  email: string;
  role: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationId?: number;
  locationIds?: number[];
}

export interface LaksvelParameterEntryResponseDto {
  development: DailyLaksvelScoreResponseDto[];
  numMeasurements: number;
  parameter: SmoltLaksvelParameter;
  score1?: number;
  score2?: number;
  score3?: number;
}

export interface Last3DaysResponseDto {
  /**
   *
   * Which implementation actually answered, after the server applied its own rules — a fish group always resolves to `core`, whatever was asked for, and a `compare` whose `core` side failed reports `sql`, because that is whose numbers were served. Always present, so a flag-driven rollout can be read off the response instead of inferred.
   */
  source: "sql" | "core" | "compare";
  /**
   *
   * Only for `source=compare`: how the two implementations differed.
   */
  parity?: LiceParityDto;
  /**
   *
   * Null when the cage has no window with enough fish to publish an average, which a caller cannot tell apart from having no data at all — and never could.
   */
  snapshot?: Last3DaysResult;
}

export interface Last3DaysResult {
  /**
   *
   * Cage the averages belong to.
   * @example
   *   1234
   */
  cageId: number;
  /**
   *
   * Caligus elongatus per fish.
   * @example
   *   0.04
   */
  caligusElongatusAvg: number;
  /**
   *
   * Change in caligusElongatusAvg against the same window one week earlier.
   * @example
   *   -0.01
   */
  caligusElongatusAvgDiff: number;
  /**
   *
   * Caligus elongatus per fish under the pre-cut-over model.
   * @example
   *   0.03
   */
  caligusElongatusLegacyAvg: number;
  /**
   *
   * Week-on-week change of caligusElongatusLegacyAvg.
   * @example
   *   -0.01
   */
  caligusElongatusLegacyAvgDiff: number;
  /**
   *
   * Last day of the three-day window.
   * @example
   *   2026-06-01
   */
  day: string;
  /**
   *
   * Adult female lice per fish.
   * @example
   *   0.12
   */
  femaleAvg: number;
  /**
   *
   * Change in femaleAvg against the same window one week earlier.
   * @example
   *   0.02
   */
  femaleAvgDiff: number;
  /**
   *
   * Adult female lice per fish under the pre-cut-over model.
   * @example
   *   0.1
   */
  femaleLegacyAvg: number;
  /**
   *
   * Week-on-week change of femaleLegacyAvg.
   * @example
   *   0.02
   */
  femaleLegacyAvgDiff: number;
  /**
   *
   * Mobile-stage lice per fish.
   * @example
   *   0.31
   */
  movingStageAvg: number;
  /**
   *
   * Change in movingStageAvg against the same window one week earlier.
   * @example
   *   0.05
   */
  movingStageAvgDiff: number;
  /**
   *
   * Mobile-stage lice per fish under the pre-cut-over model.
   * @example
   *   0.28
   */
  movingStageLegacyAvg: number;
  /**
   *
   * Week-on-week change of movingStageLegacyAvg.
   * @example
   *   0.05
   */
  movingStageLegacyAvgDiff: number;
}

export interface LastLocation {
  cage: {
    id?: number;
    location?: { id?: number; name?: string; timezone?: string };
    name?: string;
  };
  /**
   *
   * - Format: date-time
   */
  from: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  to?: string;
}

export interface LastMeasurement {
  /**
   *
   * - Format: date-time
   */
  timestamp: string;
}

export interface LiceController_DailyLiceQueryParams {
  /**
   *
   * Daypart the counts were aggregated over.
   */
  dayPart: string;
  /**
   *
   * First day to include. Defaults to the start of the cage’s lice data.
   * - Format: date-time
   */
  dayFrom?: string;
  /**
   *
   * Last day to include. Defaults to the cage’s most recent lice data.
   * - Format: date-time
   */
  dayTo?: string;
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Implementation to answer with. Omit for the one that ships today.
   */
  source?: "sql" | "core" | "compare";
}

export interface LiceController_GetTemperatureQueryParams {
  /**
   *
   * Daypart the daily measurements were aggregated over.
   */
  daypartTag: string;
  /**
   *
   * Unused. Kept because existing clients always send it.
   */
  weightUnitTag: string;
}

export interface LiceController_Last200LiceQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Implementation to answer with. Omit for the one that ships today.
   */
  source?: "sql" | "core" | "compare";
}

export interface LiceController_LiceParityQueryParams {
  /**
   *
   * Daypart the counts were aggregated over.
   */
  dayPart: string;
  /**
   *
   * First day to include. Defaults to the start of the cage’s lice data.
   * - Format: date-time
   */
  dayFrom?: string;
  /**
   *
   * Last day to include. Defaults to the cage’s most recent lice data.
   * - Format: date-time
   */
  dayTo?: string;
  /**
   *
   * Implementation to answer with. Omit for the one that ships today.
   */
  source?: "sql" | "core" | "compare";
}

export interface LiceController_WeeklyLiceQueryParams {
  /**
   *
   * Daypart the counts were aggregated over.
   */
  dayPart: string;
  /**
   *
   * First day to include. Defaults to the start of the cage’s lice data.
   * - Format: date-time
   */
  dayFrom?: string;
  /**
   *
   * Last day to include. Defaults to the cage’s most recent lice data.
   * - Format: date-time
   */
  dayTo?: string;
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * Implementation to answer with. Omit for the one that ships today.
   */
  source?: "sql" | "core" | "compare";
}

export interface LiceOverviewDto {
  /**
   *
   * Date of lice measurement
   */
  day: string;
  /**
   *
   * Female lice average
   */
  femaleAvg: number;
  /**
   *
   * Female lice average difference
   */
  femaleAvgDiff: number;
  /**
   *
   * Female lice legacy average
   */
  femaleLegacyAvg: number;
  /**
   *
   * Female lice legacy average difference
   */
  femaleLegacyAvgDiff: number;
}

export interface LiceParityDto {
  entries: LiceParityEntryDto[];
  /**
   *
   * True when nothing differed beyond tolerance.
   */
  equal: boolean;
  /**
   *
   * Which endpoint and subject was compared, so an entry stands alone.
   * @example
   *   daily cage 8800
   */
  scope: string;
  /**
   *
   * The mode that was **asked for** — `compare` here, even when `core` failed and `sql` ended up serving. Not the same as the response's own `source`, which says which implementation actually answered. When they differ, this is a fallback and `error` says why. The runtime has always returned this; it was simply undeclared.
   */
  source: "sql" | "core" | "compare";
  /**
   *
   * Difference counts by kind.
   * @example
   *   [object Object]
   */
  summary: { [x in string | number]: any };
  /**
   *
   * Entries no declared divergence accounts for. **This, not `equal`, is the number that gates the cut-over**: a diff can be large and entirely expected, or small and alarming. Non-zero when `core` failed, because a comparison that never ran is not a clean one.
   */
  unexplained: number;
  /**
   *
   * Set when `core` could not answer, in which case there is nothing to compare, `entries` is empty, the payload came from `sql` and `source` says so. A fixed message, never the underlying failure: that stays in the API logs against the same `scope`.
   */
  error?: string;
}

export interface LiceParityEntryDto {
  /**
   *
   * `value` both sides disagree beyond tolerance; `nullness` one side has a value and the other does not; `missing` a day or week exists on one side only.
   */
  kind: "value" | "nullness" | "missing";
  /**
   *
   * Dotted path, e.g. `days[2026-08-08].femaleAvg`.
   */
  path: string;
  /**
   *
   * What the `core` implementation produced.
   */
  core?: { [x in string | number]: any };
  /**
   *
   * Relative difference, for numeric `value` entries.
   * @example
   *   0.227
   */
  deltaRel?: number;
  /**
   *
   * Present when this difference matches a divergence already declared and measured. Absent means **no rule recognised it** — those are the entries worth investigating. A reason is a signature match, not a proof: a real defect shaped like a known one would be labelled too.
   */
  reason?: LiceParityReasonDto;
  /**
   *
   * What the `sql` implementation produced.
   */
  sql?: { [x in string | number]: any };
}

export interface LiceParityReasonDto {
  /**
   *
   * The declared divergence this entry matches, numbered in `docs/architecture/lice-calculation/field-provenance.md`.
   */
  code:
    "week-on-week-day-shift" | "window-start-boundary" | "snapshot-anchor-day";
  /**
   *
   * One line explaining the cause, readable without the doc.
   */
  detail: string;
  /**
   *
   * Which implementation to believe for this entry.
   */
  trust: "core" | "sql" | "undecided";
}

export interface LiceReportCages {
  cageId: number;
  count: number;
  depthAvg: number;
  depthMax: number;
  depthMin: number;
  /**
   *
   * Female lice average. Weekly reports: reporting (simulated manual count). Daily reports: raw (true_avg); use femaleReportingAvg for reporting.
   */
  femaleAvg: number;
  /**
   *
   * Female lice total. For by-day reports this is computed from the raw average.
   */
  femaleTotal: number;
  isIncluded: boolean;
  livingWeight: number;
  /**
   *
   * Moving stage lice average. For by-day reports this is the raw value; use movingStageReportingAvg for simulated manual count.
   */
  movingStageAvg: number;
  /**
   *
   * Moving stage lice total. For by-day reports this is computed from the raw average.
   */
  movingStageTotal: number;
  name: string;
  cageExternalId?: string;
  cageExternalName?: string;
  /**
   *
   * Caligus elongatus average. For by-day reports this is the raw value; use caligusElongatusReportingAvg for simulated manual count.
   */
  caligusElongatusAvg?: number;
  /**
   *
   * Raw caligus elongatus average for by-day reports.
   */
  caligusElongatusRawAvg?: number;
  /**
   *
   * Raw caligus elongatus total for by-day reports.
   */
  caligusElongatusRawTotal?: number;
  /**
   *
   * Reporting caligus elongatus average for by-day reports (simulated manual count).
   */
  caligusElongatusReportingAvg?: number;
  /**
   *
   * Reporting caligus elongatus total for by-day reports (simulated manual count).
   */
  caligusElongatusReportingTotal?: number;
  /**
   *
   * Caligus elongatus total. For by-day reports this is computed from the raw average.
   */
  caligusElongatusTotal?: number;
  day?: string;
  /**
   *
   * Raw female lice average for by-day reports.
   */
  femaleRawAvg?: number;
  /**
   *
   * Raw female lice total for by-day reports.
   */
  femaleRawTotal?: number;
  /**
   *
   * Reporting female lice average for by-day reports (simulated manual count).
   */
  femaleReportingAvg?: number;
  /**
   *
   * Reporting female lice total for by-day reports (simulated manual count).
   */
  femaleReportingTotal?: number;
  /**
   *
   * Raw moving stage lice average for by-day reports.
   */
  movingStageRawAvg?: number;
  /**
   *
   * Raw moving stage lice total for by-day reports.
   */
  movingStageRawTotal?: number;
  /**
   *
   * Reporting moving stage lice average for by-day reports (simulated manual count).
   */
  movingStageReportingAvg?: number;
  /**
   *
   * Reporting moving stage lice total for by-day reports (simulated manual count).
   */
  movingStageReportingTotal?: number;
}

export interface LiceReportLocations {
  /**
   *
   * Cages of this location.
   */
  cages: LiceReportCages[];
  /**
   *
   * Internal location id.
   * @example
   *   42
   */
  id: number;
  /**
   *
   * Location name.
   * @example
   *   Hitra Nord
   */
  name: string;
}

export interface LiceType {
  id: number;
  is_default: boolean;
  name: string;
  shortName: string;
}

export interface LiceTypeInfo {
  /**
   *
   * Lice type ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default lice type
   * @example
   *   true
   */
  is_default: boolean;
  /**
   *
   * Lice type name
   * @example
   *   Lepeophtheirus salmonis
   */
  name: string;
  /**
   *
   * Short name
   * @example
   *   LS
   */
  shortName: string;
}

export interface LicenseClient {
  clientLicenses: ClientLicenseWithLicense[];
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  featureFlags: string[];
  id: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  archived?: boolean;
  /**
   *
   * - Format: date-time
   */
  archivedAt?: string;
  living_weight_adj_pct?: number;
  name?: string;
}

export interface LicenseClientLocation {
  clientId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  dWeightFixPct: number;
  deleted: boolean;
  id: number;
  lWeightFixPct: number;
  lice_area_id: number;
  lice_type_id: number;
  location_type_id: number;
  name: string;
  rWeightFixPct: number;
  sWeightFixPct: number;
  sWeightPct: number;
  timezone: string;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  weight_stddev_ff: number;
  aquacultureSiteId?: number;
  feedingSystemLocationId?: number;
  feedingSystemType?: string;
  fishtypeid?: number;
  latitude?: number;
  longitude?: number;
}

export interface LicenseClientUser {
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  locationIds: number[];
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  userLicenses: UserLicenseRecord[];
  clientId?: number;
  clients?: LicenseClient;
  role?: string;
  userId?: number;
}

export interface LicenseInfo {
  code: string;
  description: string;
  id: number;
  name: string;
}

export interface LicenseRecord {
  code: string;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  description: string;
  id: number;
  name: string;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface LicenseResponse {
  clientId: number;
  clientLicenseId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  left: number;
  licenseId: number;
  licenses: LicenseRecord;
  name: string;
  numLicenses: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  userLicenses: UserLicenseWithClientUser[];
}

export interface LicenseUser {
  clientUsers: LicenseClientUser[];
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  emailConfirmed: boolean;
  featureFlags: string[];
  id: number;
  opFlags: string[];
  permissions: string[];
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  email?: string;
  firstName?: string;
  /**
   *
   * - Format: date-time
   */
  lastLogin?: string;
  lastName?: string;
  systemRole?: string;
}

export interface LicenseValidity {
  hadLicenseBefore: boolean;
  hasValidLicense: boolean;
}

export interface Licenses {
  behaviorLicense: LicenseValidity;
  biomassLicense: LicenseValidity;
  fishHealthLicense: LicenseValidity;
  fishSpeedLicense: LicenseValidity;
  laksvelLicense: LicenseValidity;
  liceLicense: LicenseValidity;
  liveStreamLicense: LicenseValidity;
}

export interface LineageEdgeDto {
  destinationId: number;
  sourceId: number;
  transfer: FishGroupTransferDto;
}

export interface LineageFlatDto {
  ancestors: LineageFlatEntryDto[];
  descendants: LineageFlatEntryDto[];
}

export interface LineageFlatEntryDto {
  /**
   *
   * Absolute closure depth (>= 1). Distance in DAG edges from the root to this fish group.
   */
  depth: number;
  fishGroup: FishGroupDto;
}

export interface LineageGraphDto {
  edges: LineageEdgeDto[];
  nodes: LineageNodeDto[];
}

export interface LineageNodeDto {
  /**
   *
   * Shortest path length from the requested root. 0 = root, positive = descendant, negative = ancestor.
   */
  depth: number;
  fishGroup: FishGroupDto;
  id: number;
  /**
   *
   * ID of the cage where this fish group currently lives (active group) or last lived (closed/discarded). Resolved from the most recent non-soft-deleted fish_group_locations row.
   */
  currentCageId?: number;
  /**
   *
   * Name of the cage referenced by currentCageId. Null when the fish group has no fish_group_locations row yet (e.g. pending).
   */
  currentCageName?: string;
}

export interface LocalizedString {
  en: string;
  es: string;
  nb: string;
}

export interface LocationAveragesDto {
  /**
   *
   * Average downgrade rate across active cages
   */
  downgrade?: number;
  /**
   *
   * Average female lice across active cages
   */
  femaleLice?: number;
  /**
   *
   * Average growth across active cages
   */
  growth?: number;
  /**
   *
   * Average wound rate across active cages
   */
  wounds?: number;
}

export interface LocationBioscopeStatusDto {
  errorCagesBioscopes: CageBioscopeStatus[];
  locationId: number;
  numberOfBioscopes: number;
  numberOfBioscopesMeasuring: number;
}

export interface LocationCompareResponseDto {
  /**
   *
   * Cages available for comparison at this location (active + inactive, excluding historical), sorted by name. Drives the chart legend.
   */
  cages: CompareCageDto[];
  /**
   *
   * Location ID
   * @example
   *   42
   */
  locationId: number;
  /**
   *
   * Location name, used as the page title.
   * @example
   *   Main site
   */
  locationName: string;
  /**
   *
   * Metric groups available for this location, filtered by license.
   */
  metrics: CompareMetricsDto;
}

export interface LocationController_MarkHistoricalQueryParams {
  historical: boolean;
}

export interface LocationDepthSeriesController_getLocationDepthSeriesQueryParams {
  /**
   *
   * First calendar day, inclusive, YYYY-MM-DD.
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  from: string;
  /**
   *
   * hour reads environment_sensor_data_hourly and is limited to 31 days. day reads the daily aggregate.
   */
  resolution: "hour" | "day";
  /**
   *
   * Last calendar day, inclusive, YYYY-MM-DD.
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  to: string;
}

export interface LocationFishGroupsController_timelineQueryParams {
  /**
   *
   * - Format: date
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  from?: string;
  /**
   *
   * A stocking cycle id at this site, or "unassigned".
   * - pattern: /^([1-9]\d*|unassigned)$/
   */
  stockingCycleId?: string;
  /**
   *
   * - Format: date
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  to?: string;
}

/**
 *
 * Location lice type
 */

export enum LocationLiceType {
  lice = "lice",
  chilean_lice = "chilean_lice",
}

export interface LocationMetadataDto {
  id: number;
  name: string;
  timezone: string;
}

export interface LocationOverviewDto {
  /**
   *
   * Cages with at least one active bioscope, sorted by name. With includeFishGroups=true: cages holding an active fish group and a bioscope.
   */
  activeCages: CageOverviewDto[];
  /**
   *
   * Cages flagged as historical, sorted by name
   */
  historicalCages: CageOverviewDto[];
  /**
   *
   * Cages without active bioscopes that are not yet historical, sorted by name. With includeFishGroups=true: cages holding an active fish group but no bioscope.
   */
  inactiveCages: CageOverviewDto[];
  /**
   *
   * Averages across active cages
   */
  locationAverages: LocationAveragesDto;
  /**
   *
   * Location ID
   */
  locationId: number;
  locationLiceType: LocationLiceType;
  /**
   *
   * Location name
   */
  locationName: string;
  locationType: LocationType;
  /**
   *
   * Cohorts that finished in one of this location’s cages, newest departure first. One entry per completed stay. Present only when includeFishGroups=true.
   */
  closedFishGroups?: ClosedFishGroupRowDto[];
  /**
   *
   * Non-historical cages with no active fish group, sorted by name. They carry no data. Present only when includeFishGroups=true.
   */
  emptyCages?: CageOverviewDto[];
  /**
   *
   * The default species for new pens at this location, as stored. Not a statement about what the location holds: derive that from the pens. Null when unknown.
   */
  locationFishType?: FishTypeInfo;
}

export interface LocationProviderConfigDto {
  clientId: number;
  locationId: number;
  /**
   *
   * Every pen of the site, by name.
   */
  pens: PenRefDto[];
  /**
   *
   * In provider fetch order.
   */
  providers: ProviderGroupDto[];
  /**
   *
   * Rows of a provider the page has no schema for, shown read-only.
   */
  unsupported: UnsupportedProviderDto[];
}

export interface LocationResponseDto {
  clientId: number;
  /**
   *
   * True once the site is deleted, as a delete answers
   */
  deleted: boolean;
  id: number;
  lice_type_id: number;
  location_type_id: number;
  name: string;
  timezone: string;
  aquacultureSiteId?: number;
  fishtypeid?: number;
  latitude?: number;
  longitude?: number;
}

export interface LocationStreamDto {
  bioscope_id: number;
  id: number;
  mux_stream_id: string;
  playback_id: string;
  started_by_user_id?: number;
  status?:
    | "idle"
    | "starting"
    | "connected"
    | "active"
    | "stopping"
    | "disconnected"
    | "disabled"
    | "error";
}

export interface LocationStreamStatusDto {
  bioscopeId: number;
  cageId: number;
  cageName: string;
  locationId: number;
  locationName: string;
  timezone: string;
  dailyQuotaAvailable?: DailyQuotaAvailabilityDto;
  stream?: LocationStreamDto;
}

/**
 *
 * Location type
 */

export enum LocationType {
  default = "default",
  smolt_location = "smolt_location",
  landbased = "landbased",
}

export interface LocationTypeInfo {
  /**
   *
   * Location type ID
   * @example
   *   1
   */
  id: number;
  /**
   *
   * Whether this is the default location type
   * @example
   *   true
   */
  is_default: boolean;
  /**
   *
   * Location type name
   * @example
   *   Sea cage
   */
  name: string;
  /**
   *
   * Short name
   * @example
   *   SC
   */
  shortName: string;
}

export interface LocationWeightStatusDto {
  dailyCageWeightRows: DailyCageWeightDto[];
  locationId: number;
  /**
   *
   * - Format: date-time
   */
  date?: string;
}

export interface Locations {
  cages: {
    id?: number;
    locations?: {
      clientId?: number;
      id?: number;
      name?: string;
      timezone?: string;
    };
    name?: string;
  };
  clientId: number;
  /**
   *
   * - Format: date-time
   */
  from: string;
  id: number;
  /**
   *
   * The client the unit belonged to during this placement. Null when it cannot be named.
   */
  clientName?: string;
  contractDescription?: string;
  contractId?: number;
  /**
   *
   * - Format: date-time
   */
  to?: string;
}

export interface LocationsLicenseOverview {
  contractId: number;
  description: string;
  licenses: Licenses;
  locationId: number;
}

export interface LoginForm {
  password: string;
  username: string;
}

export interface MarkCagesHistoricalRequest {
  /**
   *
   * One change per pen. Marking a pen historical closes the fish group it holds, in the same transaction.
   */
  changes: CageHistoricalChange[];
}

export interface Me {
  clients: MeClients[];
  user: MeUser;
}

export interface MeClient {
  id: number;
  locations: MeLocation[];
  name: string;
  archived?: boolean;
}

export interface MeClients {
  authLicenses: string[];
  client: MeClient;
  locationIds: number[];
  role: string;
}

export interface MeLocation {
  id: number;
  location_type_id: number;
  name: string;
}

export interface MeUser {
  email: string;
  featureFlags: string[];
  firstName: string;
  id: number;
  lastName: string;
  /**
   *
   * Named grants beyond the role, e.g. `audit_log:read`.
   */
  permissions: string[];
  systemRole: string;
  impersonatorUser?: MeUserImpersonator;
  profile?: UserProfileDto;
}

export interface MeUserImpersonator {
  email: string;
  featureFlags: string[];
  firstName: string;
  id: number;
  lastName: string;
  systemRole: string;
}

export interface MoveBioscopeQueryParams {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId: number;
  /**
   *
   * - Format: date-time
   */
  from: string;
  /**
   *
   * Target cage id. Null means the bioscope is moved onto land.
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  /**
   *
   * Contract id to use for the move. Existing contract is reused when omitted.
   * - minimum: 1
   * - max: 2147483647
   */
  contractId?: number;
}

export interface NavigationController_searchByNameQueryParams {
  /**
   *
   * Location and pen name tokens, e.g. "bogen 06"
   */
  q: string;
}

export interface NavigationMatchDto {
  /**
   *
   * Cage, bioscope, or winch id that was looked up
   * @example
   *   1596
   */
  id: number;
  /**
   * @example
   *   cage
   */
  kind: "cage" | "bioscope" | "winch";
  /**
   *
   * Bioscope that owns this winch, when kind is winch
   * @example
   *   1596
   */
  bioscopeId?: number;
  /**
   * @example
   *   42
   */
  cageId?: number;
  /**
   * @example
   *   Pen 3
   */
  cageName?: string;
  /**
   *
   * Client the match belongs to
   * @example
   *   7
   */
  clientId?: number;
  /**
   *
   * Client name, for OptoScale-admin labels
   * @example
   *   Example Seafood
   */
  clientName?: string;
  /**
   * @example
   *   3
   */
  locationId?: number;
  /**
   * @example
   *   Hitra Nord
   */
  locationName?: string;
  /**
   *
   * Display name when known
   * @example
   *   Pen 3
   */
  name?: string;
  /**
   * @example
   *   active
   */
  status?: "active" | "inactive" | "historical";
}

export interface NavigationResolveResponseDto {
  matches: NavigationMatchDto[];
}

export interface NewLocation {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  licetypeid: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationtypeid: number;
  name: string;
  timezone: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  aquacultureSiteId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  fishtypeid?: number;
  /**
   *
   * - minimum: -90
   * - max: 90
   */
  latitude?: number;
  /**
   *
   * - minimum: -180
   * - max: 180
   */
  longitude?: number;
}

export interface NewReport {
  lastFeedDay: string;
  draft?: boolean;
  slaughterDay?: string;
  temperature?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  weightUnitId?: number;
  weight_max?: number;
  weight_min?: number;
}

export interface OccupiedPenDto {
  cageId: number;
  /**
   *
   * The group holding the pen.
   */
  fishGroupId: number;
  fishGroupName: string;
  /**
   *
   * pending for a stocking registered ahead.
   * @example
   *   pending
   */
  fishGroupStatus: string;
  /**
   *
   * The group's species (fish type id).
   */
  fishTypeId: number;
  /**
   *
   * When the open stay starts; later than now for a stocking registered ahead.
   * - Format: date-time
   */
  from: string;
  /**
   *
   * The group's stocking cycle; null when it is in none.
   */
  stockingCycleId?: number;
}

export interface OccupiedPensDto {
  locationId: number;
  /**
   *
   * Every pen at the site that an open stay holds, whatever its cycle or start date. A new group cannot go into any of them.
   */
  pens: OccupiedPenDto[];
}

export interface OperationDestinationDto {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId: number;
  name: string;
  receivesFrom: DestinationInflowDto[];
  /**
   *
   * - minimum: 1
   */
  estimatedFishCount?: number;
  notes?: string;
}

export interface OperationResponseDto {
  destinationsCreated: FishGroupDto[];
  eventsLogged: number;
  /**
   *
   * - Format: date-time
   */
  operationTimestamp: string;
  sourcesClosed: FishGroupDto[];
  success: boolean;
  transfersCreated: FishGroupTransferDto[];
}

export interface OperationSourceDto {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId: number;
}

export interface OverviewCageDto {
  /**
   *
   * Bioscope ids currently assigned to this cage (0 entries = inactive cage, 1 entry = active).
   */
  activeBioscopes: number[];
  cageId: number;
  cageName: string;
  activeFishGroup?: OverviewFishGroupSummaryDto;
}

export interface OverviewFishGroupSummaryDto {
  /**
   *
   * Start of this group’s stay in the cage (fish_group_locations.fromDate). This — not lifecycleStartedAt — is the period that bounds the cage’s data, because measurements are keyed by (cage, day) and a relocated group has one interval per cage.
   * - Format: date-time
   */
  fromDate: string;
  id: number;
  name: string;
  status: "active" | "closed" | "discarded";
  /**
   *
   * - Format: date-time
   */
  lifecycleStartedAt?: string;
}

export interface OverviewLocationDto {
  activeCages: OverviewCageDto[];
  inactiveCages: OverviewCageDto[];
  locationId: number;
  locationName: string;
}

export interface OverviewResponseDto {
  /**
   *
   * Averages for the last 3 days
   */
  averages: BehaviorAveragesDto;
  /**
   *
   * Latest environmental factors
   */
  environmentalFactors: EnvironmentalFactorsDto;
  /**
   *
   * Whether the bioscope was recently deployed
   * @example
   *   true
   */
  isBioscopeRecentlyDeployed: boolean;
  /**
   *
   * Current respiration percentages
   */
  respirationPercentages: RespirationPercentagesDto;
}

export interface PenFieldValueDto {
  cageId: number;
  /**
   *
   * Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  list?: string[];
  /**
   *
   * Both null when unset, and for a client admin when the stored value is one the field cannot read (see `unreadable`).
   */
  text?: string;
}

export interface PenOverviewItemDto {
  activeTaskCount: number;
  cageId: number;
  cageName: string;
  status: { [x in string | number]: any };
  bioscopeId?: number;
  bioscopeStatus?: { [x in string | number]: any };
  lastMeasurement?: string;
  /**
   *
   * Number of lice measurements recorded today (location timezone) for daypart 'day'. Null when no row exists for today. Returned regardless of statistical threshold — low counts are valid signal that the bioscope hasn't accumulated enough samples yet.
   */
  liceMeasurementCount?: number;
  /**
   *
   * ISO timestamp of when the 3-hourly batch last updated liceMeasurementCount. Null when liceMeasurementCount is null.
   */
  liceMeasurementCountAsOf?: string;
  /**
   *
   * Number of weight measurements recorded today (location timezone) for daypart 'day'. Null when no row exists for today — the 3-hourly batch hasn't yet written a row for this pen.
   */
  weightMeasurementCount?: number;
  /**
   *
   * ISO timestamp of when the 3-hourly batch last updated weightMeasurementCount. Null when weightMeasurementCount is null.
   */
  weightMeasurementCountAsOf?: string;
}

export interface PenOverviewResponseDto {
  /**
   *
   * Lightweight list of every (non-deleted, non-historical) pen at the location, including pens with no current bioscope assignment. Powers the AddActivityModal pen selector so operators can log activities against any pen — not just bioscope-assigned ones shown in the grid.
   */
  allPens: PenSummaryDto[];
  locationId: number;
  locationName: string;
  pens: PenOverviewItemDto[];
  /**
   *
   * IANA timezone of the site. Depth hours are this clock, not the browser's.
   * @example
   *   Europe/Oslo
   */
  timezone: string;
}

export interface PenPatchDto {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId: number;
  /**
   *
   * The `updatedAt` the page loaded with `rowId`; a different instant is a conflict.
   */
  expectedUpdatedAt?: string;
  fields?: FieldPatchDto[];
  isActive?: boolean;
  /**
   *
   * Delete the pen row. Refused while it has feeding data.
   */
  remove?: boolean;
  /**
   *
   * The row the page loaded for this pen; null or absent creates one.
   * - minimum: 1
   * - max: 2147483647
   */
  rowId?: number;
  secrets?: SecretsPatchDto;
}

export interface PenRefDto {
  cageId: number;
  name: string;
}

export interface PenSummaryDto {
  cageId: number;
  cageName: string;
}

export interface ProviderAccountDto {
  authType: ProviderAuthType;
  /**
   *
   * Whether each secret is set, never its value.
   */
  credentials: RowCredentialDto[];
  /**
   *
   * Every non-secret schema field.
   */
  fields: FieldValueDto[];
  isActive: boolean;
  providerName: string;
  /**
   *
   * Empty when unsupported.
   */
  schemaFields: ProviderFieldSchemaDto[];
  /**
   *
   * Stored extra_config leaves no account schema field reads; read-only.
   */
  storedExtras: StoredExtraDto[];
  /**
   *
   * False for a row the portal has no schema for; it is shown read-only.
   */
  supported: boolean;
  /**
   *
   * Values stored at an account field key that the field cannot read; a `blocked` one cannot be saved.
   */
  unreadable: UnreadableValueDto[];
  /**
   *
   * The neutral name to show for the account, as a key under providerConfig.accounts.types; the provider name can name a customer. Null when unsupported.
   */
  displayKey?: string;
  /**
   *
   * Null for an account the portal can create but no row holds yet.
   */
  rowId?: number;
  /**
   *
   * ISO 8601, UTC; send it back as `expectedUpdatedAt` on save. Null without a row.
   */
  updatedAt?: string;
}

export enum ProviderAuthType {
  api_key = "api_key",
  oauth2_client_credentials = "oauth2_client_credentials",
  bearer_token = "bearer_token",
}

/**
 *
 * `varies` when the pens hold different ciphertext, which includes the same secret set on each pen separately.
 */

export enum ProviderCredentialState {
  set = "set",
  notSet = "notSet",
  varies = "varies",
}

/**
 *
 * How to show the value when its kind does not say: `machine` is an identifier in a text field, shown in monospace. Null for the kind's own look.
 */

export enum ProviderFieldDisplay {
  machine = "machine",
}

export enum ProviderFieldKind {
  url = "url",
  host = "host",
  text = "text",
  integer = "integer",
  secret = "secret",
  integerList = "integerList",
  stringList = "stringList",
  identifier = "identifier",
  qualifiedName = "qualifiedName",
  clarifyItem = "clarifyItem",
  enum = "enum",
  date = "date",
  scadaItems = "scadaItems",
}

export interface ProviderFieldSchemaDto {
  /**
   *
   * Shown to every viewer; only an OptoScale admin may change it (`advancedField` otherwise).
   */
  advanced: boolean;
  /**
   *
   * A column name, or a dotted path under `extra_config` or `signal_mappings`. Also the key of the field in every value list of the location read.
   */
  key: string;
  kind: ProviderFieldKind;
  /**
   *
   * i18n key; the frontend owns the text.
   */
  labelKey: string;
  required: boolean;
  scope: ProviderFieldScope;
  /**
   *
   * What the fetch uses while the field is empty.
   */
  defaultValue?: string;
  display?: ProviderFieldDisplay;
  enumValues?: string[];
  helpKey?: string;
  /**
   *
   * Most entries a list may hold.
   */
  max?: number;
  /**
   *
   * The signal or role a generated label names.
   */
  subject?: string;
}

export enum ProviderFieldScope {
  site = "site",
  pen = "pen",
}

export interface ProviderGroupDto {
  authType: ProviderAuthType;
  /**
   *
   * Site-scoped schema fields.
   */
  connection: ConnectionValueDto[];
  credentials: CredentialStatusDto[];
  providerName: string;
  rows: ProviderRowDto[];
}

export interface ProviderRowDto {
  cageId: number;
  credentials: RowCredentialDto[];
  /**
   *
   * Pen-scoped schema fields.
   */
  fields: FieldValueDto[];
  health: RowHealthDto;
  isActive: boolean;
  rowId: number;
  /**
   *
   * Stored signal_mappings and extra_config leaves no schema field reads; shown read-only to every viewer.
   */
  storedExtras: StoredExtraDto[];
  /**
   *
   * Values stored at a shown field key that the field cannot read.
   */
  unreadable: UnreadableValueDto[];
  /**
   *
   * ISO 8601, UTC; send it back as `expectedUpdatedAt` on save.
   */
  updatedAt: string;
  /**
   *
   * The row note, e.g. the external basin the pen maps to.
   */
  description?: string;
}

export interface ProviderSchemaDto {
  authType: ProviderAuthType;
  fields: ProviderFieldSchemaDto[];
  providerName: string;
}

export enum ProviderSecretName {
  apiKey = "apiKey",
  clientId = "clientId",
  clientSecret = "clientSecret",
}

export interface QuotaCheckResponseDto {
  /**
   *
   * Daily bioscope stream quota status
   */
  status: "available" | "exceeded";
}

export interface RangeClientReportResult {
  /**
   *
   * First day of the range, inclusive.
   * @example
   *   2026-05-25
   */
  from: string;
  /**
   *
   * Every location of the client the requesting user may see.
   */
  locations: LiceReportLocations[];
  /**
   *
   * Last day of the range, inclusive.
   * @example
   *   2026-06-01
   */
  to: string;
}

export interface RangeReportResult {
  /**
   *
   * First day of the range, inclusive.
   * @example
   *   2026-05-25
   */
  from: string;
  location: LiceReportLocations;
  /**
   *
   * Last day of the range, inclusive.
   * @example
   *   2026-06-01
   */
  to: string;
}

export interface RecordFishGroupEventRequest {
  /**
   *
   * Event kind. Lifecycle event types (created, closed, relocated) are rejected.
   */
  eventType:
    | "mortality"
    | "harvest"
    | "measurement"
    | "feeding"
    | "treatment"
    | "delousing";
  /**
   *
   * Free-form event-specific data (e.g. mortality cause, harvest weight, measurement readings).
   */
  eventData?: { [x in string | number]: any };
  /**
   *
   * When the event happened. Defaults to the current server time. ISO 8601.
   */
  eventDate?: string;
  /**
   *
   * Estimated population after the event.
   */
  fishCountAfter?: number;
  /**
   *
   * Estimated population before the event (e.g. before a mortality).
   */
  fishCountBefore?: number;
  notes?: string;
}

export interface RegisterUserForm {
  firstName: string;
  lastName: string;
  password: string;
  token: string;
}

export interface RelocateFishGroupRequest {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  targetCageId: number;
  /**
   *
   * Optional bioscope moves to perform atomically with the relocation. When omitted or empty the endpoint behaves exactly as before.
   */
  bioscopeMovements?: BioscopeMovementDto[];
  notes?: string;
  reason?: string;
  /**
   *
   * When the relocation happened. Defaults to the current server time. Must be ISO 8601.
   */
  relocationDate?: string;
}

export interface RelocationResponseDto {
  fishGroup: FishGroupDto;
  newCageId: number;
  previousCageId: number;
  /**
   *
   * - Format: date-time
   */
  relocationDate: string;
}

export interface ReportDetail {
  data: ReportDetailData;
  daypartTag: string;
  id: number;
  lastFeedDay: string;
  slaughterDay: string;
  status: string;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  weightUnitTag: string;
}

export interface ReportDetailData {
  bleedingLoss: number;
  cv: number;
  days: ReportDetailDay[];
  guttingWaste: number;
  guttingWastePct: number;
  hists: ReportDetailHist[];
  livingWeight: number;
  numDaysWithMeas: number;
  numMeas: number;
  roundWeight: number;
  slaughteredWeight: number;
  start: string;
  starvationLoss: number;
  starvationWeight: number;
  stop: string;
  temperature: number;
  warning: boolean;
  estimateDowngradePercentage?: number;
  numMeasQuality?: number;
  slaughteredWeightDowngrade?: number;
  slaughteredWeightSuperior?: number;
  superiorSharePercentage?: number;
  /**
 * 
 * Temporary maturation downgrade correction [%], additive to
`estimateDowngradePercentage`. Only sent to OptoScale admins: it is threshold-based
and must not reach customers. Absent when the report predates the column.
 */
  tmpMaturityDowngradePercentage?: number;
}

export interface ReportDetailDay {
  count: number;
  day: string;
  livingWeight: number;
  livingWeightTrend: number;
  stddev: number;
}

export interface ReportDetailHist {
  count: number;
  countPercentage: number;
  from: number;
  mass: number;
  massPercentage: number;
  to: number;
  downgrade_pct?: number;
  notSuperiorSharePct?: number;
  superiorSharePct?: number;
}

export interface ReportList {
  id: number;
  lastFeedDay: string;
  slaughterDay: string;
  status: string;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface ResetPassword {
  newPassword: string;
  token: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface RespirationDataPointDto {
  /**
   *
   * Date in YYYY-MM-DD format
   * @example
   *   2024-01-15
   */
  day: string;
  /**
   *
   * Whether the active frequency is uncertain
   */
  uncertainActiveFrequency: boolean;
  /**
   *
   * Whether the approved ratio is uncertain (active_count / approved_count)
   */
  uncertainApprovedRatio: boolean;
  /**
   *
   * Active respiration percentage
   * @example
   *   45
   */
  activePercent?: number;
  /**
   *
   * Number of measurements (null if not available)
   * @example
   *   100
   */
  numberOfMeasurements?: number;
  /**
   *
   * Oxygen saturation percentage
   * @example
   *   80
   */
  oxygenSaturation?: number;
  /**
   *
   * Passive respiration percentage
   * @example
   *   35
   */
  passivePercent?: number;
  /**
   *
   * Respiration in Hz
   * @example
   *   0.85
   */
  respiration?: number;
  /**
   *
   * Swim speed in KL/s (for context)
   * @example
   *   1.25
   */
  swimSpeed?: number;
}

export interface RespirationPercentagesDto {
  /**
   *
   * The site's wall-clock time of the last measurement, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when unknown.
   * @example
   *   2025-12-08T10:32:22
   */
  lastMeasurement: string;
  /**
   *
   * Active respiration percentage
   * @example
   *   45
   */
  active?: number;
  /**
   *
   * Passive respiration percentage
   * @example
   *   35
   */
  passive?: number;
}

export interface RespirationResponseDto {
  /**
   *
   * Array of respiration data points
   */
  data: RespirationDataPointDto[];
  /**
   *
   * The site's wall-clock time of the last measurement in the range, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when there is none.
   * @example
   *   2025-12-08T10:32:22
   */
  lastMeasurement: string;
}

export enum RevertBlockerCode {
  OPERATION_NOT_LATEST = "OPERATION_NOT_LATEST",
  CAGE_REUSED_SINCE = "CAGE_REUSED_SINCE",
  STATE_MISMATCH = "STATE_MISMATCH",
  SMOLT_REPORT_ON_DISCARDED_GROUP = "SMOLT_REPORT_ON_DISCARDED_GROUP",
}

export interface RevertBlockerDto {
  cageIds: number[];
  code: RevertBlockerCode;
  fishGroupIds: number[];
  message: string;
  operationIds: number[];
}

export interface RevertChildManualEventDto {
  /**
   *
   * - Format: date-time
   */
  eventDate: string;
  eventType: string;
  fishGroupId: number;
  id: string;
}

export interface RevertFishGroupOperationRequest {
  /**
   *
   * Why the operation is being reverted. Stored on the revert operation.
   * - maxLength: 255
   */
  reason: string;
  notes?: string;
}

export interface RevertGroupEffectDto {
  /**
   *
   * The cage the group is restored into, or the one it leaves.
   */
  cageId: number;
  cageName: string;
  fishGroupId: number;
  fishGroupName: string;
}

export interface RevertOperationResponseDto {
  discardedFishGroups: FishGroupDto[];
  restoredFishGroups: FishGroupDto[];
  /**
   *
   * The new operation of type revert.
   */
  revertOperationId: number;
  revertedOperationId: number;
}

export interface RevertPreviewDto {
  blockers: RevertBlockerDto[];
  /**
   *
   * Manual events recorded on a group the revert discards. They stay on it; re-record them on the restored group if they still apply.
   */
  childManualEvents: RevertChildManualEventDto[];
  /**
   *
   * Groups the operation created, which the revert discards.
   */
  discardedFishGroups: RevertGroupEffectDto[];
  /**
   *
   * - Format: date-time
   */
  operationDate: string;
  operationId: number;
  operationType: string;
  /**
   *
   * Groups the revert makes active again in the cage they were in before the operation: the groups it closed, or the group it relocated.
   */
  restoredFishGroups: RevertGroupEffectDto[];
  /**
   *
   * True when there are no blockers.
   */
  revertible: boolean;
}

export interface RowCredentialDto {
  name: ProviderSecretName;
  set: boolean;
}

export interface RowHealthDto {
  /**
   *
   * Days with data over the last 30 days, today included.
   */
  daysWithData: number;
  /**
   *
   * Whether the pen holds any data from this provider at all.
   */
  hasData: boolean;
  /**
   *
   * ISO 8601, UTC: newest fetch over the last 30 days.
   */
  lastFetchedAt?: string;
}

export interface SanityContentResponse {
  customerBannerMessages: CustomerBannerMessage[];
}

export interface SaveProviderAccountRequestDto {
  /**
   *
   * The `updatedAt` the page loaded; null or absent creates the row. A different instant, or a row that is gone, is 409 PROVIDER_CONFIG_STALE.
   */
  expectedUpdatedAt?: string;
  fields?: FieldPatchDto[];
  isActive?: boolean;
  secrets?: SecretsPatchDto;
}

export interface SaveProviderConfigRequestDto {
  /**
   *
   * Every pen the save touches; a site change must list every row of the provider.
   */
  pens: PenPatchDto[];
  /**
   *
   * Site fields, written to every row of the provider at the site.
   */
  connection?: FieldPatchDto[];
  /**
   *
   * Secrets set for every pen.
   */
  secrets?: SecretsPatchDto;
  /**
   *
   * Save without a passing test. OptoScale admins only.
   */
  testOverride?: boolean;
  /**
   *
   * The token a passing connection test returned.
   * - maxLength: 256
   */
  testToken?: string;
}

export interface SecretsPatchDto {
  /**
   *
   * - maxLength: 4096
   */
  apiKey?: string;
  /**
   *
   * - maxLength: 4096
   */
  clientId?: string;
  /**
   *
   * - maxLength: 4096
   */
  clientSecret?: string;
}

export interface SetUserClientAccessForm {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  clientId: number;
  /**
   *
   * Location IDs to grant; ignored when fullClientAccess is true
   */
  locationIds: number[];
  /**
   *
   * When true grants full client-wide access (role ADMIN, locationIds cleared)
   */
  fullClientAccess?: boolean;
}

export interface SiteDelousingDetailsDto {
  notes?: string;
  /**
   *
   * How the fish were deloused, free text (stored as eventData.type).
   * - maxLength: 255
   */
  treatmentMethod?: string;
}

export interface SiteDelousingRequest {
  /**
   *
   * When the delousing happened, ISO 8601. Defaults to now. Today or earlier, at most one month back (UTC day).
   */
  eventDate?: string;
  notes?: string;
  /**
   *
   * How the fish were deloused, free text (stored as eventData.type).
   * - maxLength: 255
   */
  treatmentMethod?: string;
}

export interface SiteRelocateFishGroupRequest {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  targetCageId: number;
  /**
   *
   * Optional bioscope moves to perform atomically with the relocation. When omitted or empty the endpoint behaves exactly as before.
   */
  bioscopeMovements?: BioscopeMovementDto[];
  /**
   *
   * A delousing registered with the move, on the same date and in the same transaction.
   */
  delousing?: SiteDelousingDetailsDto;
  notes?: string;
  reason?: string;
  /**
   *
   * When the relocation happened. Defaults to the current server time. Must be ISO 8601.
   */
  relocationDate?: string;
}

export interface SiteStockingAssignmentRequest {
  /**
   *
   * Groups of this site to add or remove. Each group's whole lineage component (every group linked to it by transfers, either way) moves with it.
   */
  fishGroupIds: number[];
  /**
   *
   * Why. Stored as the notes of each event; the board leaves it out and the service fills in where it came from.
   * - maxLength: 1000
   */
  reason?: string;
}

export interface SkippedProviderDto {
  /**
   * @example
   *   mercatus
   */
  providerName: string;
  /**
   *
   * Why the provider was passed over, at most 300 characters.
   */
  reason: string;
}

/**
 *
 * Laksvel parameters the report shows. Omitted: body wounds, fin status, gill lid and scale loss. An empty list shows none.
 */

export enum SmoltLaksvelParameter {
  bodyWounds = "bodyWounds",
  finDamage = "finDamage",
  gillLid = "gillLid",
  scaleLoss = "scaleLoss",
  snoutWounds = "snoutWounds",
  emaciation = "emaciation",
  deformity = "deformity",
  deformedJaw = "deformedJaw",
  skinBleeding = "skinBleeding",
  cataract = "cataract",
  eyeDamage = "eyeDamage",
  maturity = "maturity",
}

export interface SmoltReportController_createReportQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
}

export interface SmoltReportCreateResponseDto {
  cageId: number;
  createdAt: string;
  deliveryDate: string;
  reportId: number;
  status: "finished" | "warning" | "error";
  stockingDate: string;
  warnings: SmoltReportWarningsResponseDto;
  /**
   *
   * Fish group the report was computed for; null when it was computed for the cage.
   */
  fishGroupId?: number;
  lastFeedingDate?: string;
}

export interface SmoltReportDetailResponseDto {
  cageId: number;
  createdAt: string;
  deliveryDate: string;
  id: number;
  includedParameters: SmoltLaksvelParameter[];
  status: "finished" | "warning" | "error";
  stockingDate: string;
  warnings: SmoltReportWarningsResponseDto;
  weightData: SmoltWeightDataResponseDto;
  /**
   *
   * Fish group the report was computed for; null when it was computed for the cage.
   */
  fishGroupId?: number;
  lastFeedingDate?: string;
  /**
   *
   * Null when the report holds no welfare figures; the choice above is still given.
   */
  welfareData?: SmoltWelfareDataResponseDto;
}

export interface SmoltReportListResponseDto {
  cageId: number;
  createdAt: string;
  deliveryDate: string;
  id: number;
  status: "finished" | "warning" | "error";
  stockingDate: string;
  warnings: SmoltReportWarningsResponseDto;
  /**
   *
   * Fish group the report was computed for; null when it was computed for the cage.
   */
  fishGroupId?: number;
  lastFeedingDate?: string;
}

export interface SmoltReportWarningsResponseDto {
  /**
   *
   * Delivery more than 3 days after `weightData.lastMeasurementDay`; false on older reports.
   */
  dataEndsBeforeDelivery: boolean;
  /**
 * 
 * Last weight reading more than 3 days before the last feeding date, or before delivery
without one. False here whenever `dataEndsBeforeDelivery` is raised, which replaces it.
 */
  weightDataLatency: boolean;
  weightLowFrequency: boolean;
  weightPeriodTooShort: boolean;
  welfareInsufficientSample: boolean;
  welfareLowCoverage: boolean;
}

export interface SmoltWeightDataResponseDto {
  distribution: WeightDistributionBucketResponseDto[];
  numMeasurements: number;
  timeSeries: DailyWeightTimeSeriesResponseDto[];
  conditionFactor?: number;
  cv?: number;
  /**
   *
   * Day the distribution is from, the newest on or before delivery; null when there is none.
   */
  distributionDay?: string;
  growth?: number;
  /**
   *
   * Midpoint of the heaviest occupied distribution bucket, in grams.
   */
  largestFish?: number;
  /**
   *
   * Last day with a weight measurement; null when there is none, or the report predates it.
   */
  lastMeasurementDay?: string;
  liveWeight?: number;
  /**
   *
   * Living weight on the last feeding day. Null when the report has none, or predates it.
   */
  liveWeightAtLastFeeding?: number;
  sgr?: number;
  /**
   *
   * Midpoint of the lightest occupied distribution bucket, in grams.
   */
  smallestFish?: number;
}

export interface SmoltWelfareDataResponseDto {
  /**
   *
   * The included score parameters with figures, in report order.
   */
  laksvelParameters: LaksvelParameterEntryResponseDto[];
  numMeasurements: number;
  /**
   *
   * Null when body wounds are not included.
   */
  fishWithoutWounds?: number;
  /**
   *
   * Null when body wounds are not included.
   */
  totalWounds?: number;
  /**
   *
   * Last day of the welfare window; null on reports stored before it was recorded.
   */
  windowEnd?: string;
  /**
   *
   * Null when body wounds are not included.
   */
  wounds?: WoundsDataResponseDto;
}

export interface SmsInput {
  Body: string;
  From: string;
  To: string;
}

export interface StartedBioscopeRestart {
  id: number;
  isDone: boolean;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  message?: string;
  /**
   *
   * Set once the shutdown SMS is sent
   */
  shutdownSmsId?: number;
  /**
   *
   * Set once the start SMS is sent
   */
  startSmsId?: number;
}

export interface StartedBioscopeRouterRestart {
  id: number;
  isDone: boolean;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  message?: string;
  /**
   *
   * Set once the router's reply to the reboot SMS arrives
   */
  rebootResponseId?: number;
  /**
   *
   * Set once the reboot SMS is sent
   */
  rebootSmsId?: number;
}

export interface StatusFlags {
  id: number;
  level: number;
  name: string;
  pos: number;
  color?: string;
}

export interface StockingCycleDto {
  /**
   *
   * Member groups that are pending or active.
   */
  activeGroupCount: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  /**
   *
   * Member groups, excluding discarded ones.
   */
  groupCount: number;
  id: number;
  /**
   *
   * Completed, nothing stocked at the site since its last close, no other cycle there active, and no live group, assigned or not, in any of its cages.
   */
  isFallowing: boolean;
  locationId: number;
  name: string;
  /**
   *
   * Derived from the member groups: planned (none), active (any pending or active), completed (all ended). Discarded groups do not count.
   */
  status: "planned" | "active" | "completed";
  /**
   *
   * First stocking of the next cycle at the site, which ended the fallowing.
   * - Format: date-time
   */
  fallowingUntil?: string;
  /**
   *
   * The last group close. Only set once the cycle is completed.
   * - Format: date-time
   */
  lastClosedAt?: string;
  notes?: string;
  /**
   *
   * - Format: date
   * @example
   *   2026-08-01
   */
  plannedStartDate?: string;
  /**
   *
   * Earliest start among the root groups (groups no transfer leads into).
   * - Format: date-time
   */
  stockedFrom?: string;
  /**
   *
   * Latest start among the root groups.
   * - Format: date-time
   */
  stockedTo?: string;
}

export interface StockingCycleListDto {
  /**
   *
   * Non-deleted cycles, newest first.
   */
  cycles: StockingCycleDto[];
  locationId: number;
  /**
   *
   * Prefill for a new cycle created today: the season convention (e.g. 26A), suffixed when that name is taken at the site.
   */
  suggestedName: string;
  /**
   *
   * Groups with a stay at this site that belong to no cycle (discarded groups excluded).
   */
  unassignedGroupCount: number;
}

export interface StockingCycleWarningDto {
  code: "CONCURRENT_ACTIVE_CYCLE";
  message: string;
  /**
   *
   * The other cycle at the site that is already active.
   */
  otherCycleId: number;
}

export interface StockingCyclesController_assignFishGroupsQueryParams {
  /**
   *
   * Compute the cascade and warnings without writing anything.
   */
  dryRun?: boolean;
}

export interface StockingLineageDto {
  /**
   *
   * Whether the site's type expects one ongoing stocking at a time (sea sites). An assignment that leaves another stocking ongoing beside the target then answers a CONCURRENT_ACTIVE_CYCLE warning, so the board can warn before it is sent.
   */
  expectsSingleActiveCycle: boolean;
  fishGroupId: number;
  /**
   *
   * The groups that would move with it, oldest start first. Only the requested group while a blocker is set, so no other site or client is described.
   */
  groups: StockingLineageGroupDto[];
  /**
   *
   * The stockings members are already in, lowest id first. One: the rest can only join that one. Several: no stocking can take the component.
   */
  stockingCycleIds: number[];
  /**
   *
   * Why a site manager cannot change its stocking: a member of another client, or a stay at another site.
   */
  blocker?: "LINEAGE_SPANS_CLIENTS" | "LINEAGE_SPANS_SITES";
}

export interface StockingLineageGroupDto {
  fishGroupId: number;
  name: string;
  /**
   *
   * The group the preview was asked for.
   */
  requested: boolean;
  status: string;
  /**
   *
   * - Format: date-time
   */
  startedAt?: string;
  stockingCycleId?: number;
}

export interface StoredExtraDto {
  /**
   *
   * The value is withheld from this viewer (a client admin): the page shows "Set by OptoScale".
   */
  hidden: boolean;
  /**
   *
   * Full dotted path, with [n] for a list entry.
   */
  path: string;
  /**
   *
   * JSON text of the stored value; null when `hidden`.
   */
  value?: string;
}

export interface StreamResponseDto {
  /**
   *
   * The stream row id, as text
   */
  id: string;
  /**
   *
   * Playback ID for viewing the stream
   */
  playbackId: string;
  /**
   *
   * Current status of the stream
   */
  status?:
    | "idle"
    | "starting"
    | "connected"
    | "active"
    | "stopping"
    | "disconnected"
    | "disabled"
    | "error";
}

export interface SwimSpeedDataPointDto {
  /**
   *
   * Date in YYYY-MM-DD format
   * @example
   *   2024-01-15
   */
  day: string;
  /**
   *
   * Swim speed with active respiration KL/s
   * @example
   *   1.25
   */
  activeSwimSpeed?: number;
  /**
   *
   * Depth in meters
   * @example
   *   10.2
   */
  depth?: number;
  /**
   *
   * Number of active measurements (null if not available)
   * @example
   *   100
   */
  numberOfActiveMeasurements?: number;
  /**
   *
   * Number of measurements (null if not available)
   * @example
   *   100
   */
  numberOfMeasurements?: number;
  /**
   *
   * Oxygen saturation percentage
   * @example
   *   80
   */
  oxygenSaturation?: number;
  /**
   *
   * Swim speed in KL/s
   * @example
   *   1.25
   */
  swimSpeed?: number;
  /**
   *
   * Temperature in Celsius
   * @example
   *   8.5
   */
  temperature?: number;
}

export interface SwimSpeedOverviewDto {
  /**
   *
   * Timestamp of the last swim speed measurement
   * @example
   *   2024-01-15T14:30:00.000Z
   */
  lastSpeedMeasurement: string;
  /**
   *
   * Latest swim speed value
   * @example
   *   1.25
   */
  swimSpeed: number;
  daypartTag?: DaypartTag;
}

export interface SwimSpeedResponseDto {
  /**
   *
   * Array of swim speed data points
   */
  data: SwimSpeedDataPointDto[];
  /**
   *
   * The site's wall-clock time of the last measurement in the range, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when there is none.
   * @example
   *   2025-12-08T10:32:22
   */
  lastMeasurement: string;
}

export interface TaskListResponseDto {
  locationId: number;
  summary: {
    active?: number;
    completed?: number;
    ignored?: number;
    total?: number;
  };
  tasks: TaskResponseDto[];
}

export interface TaskResponseDto {
  autoResolved: boolean;
  createdAt: string;
  id: number;
  ignoredPermanently: boolean;
  locationId: number;
  priority: string;
  recurrenceCount: number;
  status: string;
  /**
 * 
 * Variables (e.g. `penName`, `lastMeasurement`, `depthLimit`) used by the
frontend to render the task title/description from `alertCode` via i18next.
Always populated for tasks (every task is alert-derived).
 */
  templateVariables: { [x in string | number]: any };
  type: string;
  alertCode?: string;
  alertId?: number;
  bioscopeId?: number;
  cageId?: number;
  cageName?: string;
  category?: string;
  completedAt?: string;
  ignoredUntil?: string;
}

export interface TasksController_getTasksQueryParams {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId?: number;
  status?: "active" | "completed" | "ignored";
}

export interface TemperatureResult {
  /**
   *
   * Day the temperature was measured, as a date-only column.
   * - Format: date-time
   * @example
   *   2026-06-01
   */
  day: string;
  /**
   *
   * Sea temperature in degrees Celsius as measured by the bioscope.
   * @example
   *   8.4
   */
  temperature: number;
}

export interface TestPenRequestDto {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageId: number;
  /**
   *
   * Unsaved values of this pen.
   */
  fields?: FieldPatchDto[];
  secrets?: SecretsPatchDto;
}

export interface TestPenResultDto {
  cageId: number;
  /**
   *
   * Days in the window with at least one value.
   */
  daysWithData: number;
  /**
   *
   * Signals that arrived; never their values.
   */
  signals: string[];
  status:
    | "ok"
    | "config_incomplete"
    | "auth_failed"
    | "unreachable"
    | "no_data"
    | "error";
  message?: string;
  /**
   *
   * A known cause of the failure, for the page to name; null when the status says all there is.
   */
  reason?:
    "stored_credential_undecryptable" | "timed_out" | "scada_item_unknown";
  /**
   *
   * A Clarify pen's SCADA items looked up in the account's item list; null for a pen without SCADA items or another provider. Never sample values.
   */
  scada?: TestScadaResultDto;
}

export interface TestProviderConfigRequestDto {
  pens: TestPenRequestDto[];
  /**
   *
   * Unsaved site fields.
   */
  connection?: FieldPatchDto[];
  /**
   *
   * Unsaved set-for-all secrets.
   */
  secrets?: SecretsPatchDto;
}

export interface TestProviderConfigResultDto {
  /**
   * @example
   *   2026-10-04
   */
  from: string;
  results: TestPenResultDto[];
  /**
   * @example
   *   2026-10-06
   */
  to: string;
  /**
   *
   * Present only when every change was reached (ok or no_data): each pen with its own typed secret or connection values, and for a site change at least one pen that used it. The save of exactly these values needs it.
   */
  testToken?: string;
}

export interface TestScadaResultDto {
  /**
   *
   * Mapped items the Clarify account lists.
   */
  found: number;
  /**
   *
   * SCADA items mapped on the pen.
   */
  itemCount: number;
  /**
   *
   * The pen maps no daily signal, so this check is its whole test.
   */
  scadaOnly: boolean;
  /**
   *
   * Mapped item ids the full account list does not contain.
   */
  unknown: string[];
  /**
   *
   * Mapped items missing from a listing that was cut at its limit, so neither found nor known to be missing.
   */
  unverified: number;
}

export interface TiltDataPointDto {
  /**
   *
   * Date in YYYY-MM-DD format
   * @example
   *   2024-01-15
   */
  day: string;
  /**
   *
   * Depth in meters (null if not available)
   * @example
   *   10.2
   */
  depth?: number;
  /**
   *
   * Number of measurements (null if not available)
   * @example
   *   100
   */
  numberOfMeasurements?: number;
  /**
   *
   * Oxygen saturation percentage (null if not available)
   * @example
   *   80
   */
  oxygenSaturation?: number;
  /**
   *
   * Temperature in Celsius (null if not available)
   * @example
   *   8.5
   */
  temperature?: number;
  /**
   *
   * Tilt in degrees (null if not available)
   * @example
   *   15.5
   */
  tilt?: number;
}

export interface TiltResponseDto {
  /**
   *
   * Array of tilt data points
   */
  data: TiltDataPointDto[];
  /**
   *
   * The site's wall-clock time of the last measurement in the range, as the bioscope's clock read it: `YYYY-MM-DDTHH:mm:ss` with no zone, since it names no instant. Show it as sent. Empty when there is none.
   * @example
   *   2025-12-08T10:32:22
   */
  lastMeasurement: string;
}

export interface TimelineBioscopeCoverageDto {
  bioscopeId: number;
  /**
   *
   * Clipped to the stay.
   * - Format: date-time
   */
  from: string;
  /**
   *
   * - Format: date-time
   */
  to?: string;
}

export interface TimelineEventDto {
  /**
   *
   * - Format: date-time
   */
  eventDate: string;
  /**
   *
   * created, closed, relocated, harvest (partial), delousing, mortality, measurement, feeding or treatment. Metadata corrections are left out.
   */
  eventType: string;
  id: string;
  /**
   *
   * Sources for "created", destinations for "closed"; only groups this response describes.
   */
  relatedFishGroupIds: number[];
  cageId?: number;
  /**
   *
   * The event payload, e.g. previous/new cage for "relocated". A move off this site is reduced to { movedOffSite: true }; an arrival from another site carries movedFromOffSite: true and no previous cage.
   */
  eventData?: { [x: string]: any };
  fishCountAfter?: number;
  fishCountBefore?: number;
  notes?: string;
  operation?: TimelineOperationDto;
}

export interface TimelineExternalGroupDto {
  id: number;
  name: string;
  status: string;
  stockingCycleId?: number;
}

export interface TimelineFishGroupDto {
  /**
   *
   * Destinations of transfers that happened at this site.
   */
  childIds: number[];
  /**
   *
   * Events at this site, oldest first.
   */
  events: TimelineEventDto[];
  fishType: TimelineFishTypeDto;
  id: number;
  name: string;
  /**
   *
   * Lineage links to groups at another site, one per direction, with nothing about the other end.
   */
  offSiteLinks: TimelineOffSiteLinkDto[];
  /**
   *
   * Sources of transfers that happened at this site, in or out of scope.
   */
  parentIds: number[];
  status: "pending" | "active" | "closed" | "harvested" | "merged" | "split";
  /**
   *
   * Stays at this site, oldest first.
   */
  stays: TimelineStayDto[];
  /**
   *
   * The latest licensed estimate over its stays at this site; for an ended group, its weight when it ended. Days at another site are never used.
   */
  weight: TimelineWeightDto;
  /**
   *
   * What ended the group (a closure with reason "harvested", a split, a merge, ...). Null while live.
   */
  endedBy?: TimelineOperationDto;
  /**
   *
   * Informational: the latest event count at this site (fishCountAfter), else the initial population.
   */
  estimatedCount?: number;
  /**
   *
   * - Format: date-time
   */
  estimatedCountAsOf?: string;
  /**
   *
   * - Format: date
   */
  firstMeasurementDate?: string;
  initialPopulationSize?: number;
  /**
   *
   * - Format: date-time
   */
  lifecycleEndedAt?: string;
  /**
   *
   * - Format: date-time
   */
  lifecycleStartedAt?: string;
  stockingCycleId?: number;
}

export interface TimelineFishTypeDto {
  id: number;
  /**
   * @example
   *   Salmon
   */
  name: string;
  /**
   * @example
   *   salmon
   */
  shortName: string;
}

export interface TimelineOffSiteLinkDto {
  /**
   *
   * fromOffSite: the group came from a transfer at another site (e.g. created there, then moved here). toOffSite: a transfer at another site took fish from it (e.g. it moved away and was split there).
   */
  direction: "fromOffSite" | "toOffSite";
}

export interface TimelineOperationDto {
  id: number;
  /**
   * @example
   *   split
   */
  operationType: string;
  /**
   *
   * Free text; "grading" labels a split started from Grading.
   */
  reason?: string;
}

export interface TimelineScopeDto {
  kind: "cycle" | "unassigned" | "window";
  /**
   *
   * Window start; only for kind "window".
   * - Format: date
   */
  from?: string;
  stockingCycleId?: number;
  /**
   *
   * Window end; only for kind "window".
   * - Format: date
   */
  to?: string;
}

export interface TimelineStayDto {
  /**
   *
   * Bioscopes in the pen during the stay. Empty means "No Bioscope".
   */
  bioscopes: TimelineBioscopeCoverageDto[];
  cageId: number;
  cageName: string;
  /**
   *
   * - Format: date-time
   */
  from: string;
  id: number;
  /**
   *
   * The latest estimate on a day of this stay that a biomass licence covers, in the same day frame as the fish group measurement views.
   */
  weight: TimelineWeightDto;
  /**
   *
   * First day with measurements in the pen during the stay, with the same day boundaries as the fish group measurement views.
   * - Format: date
   */
  firstMeasurementDate?: string;
  reason?: string;
  /**
   *
   * - Format: date-time
   */
  to?: string;
}

export interface TimelineTransferDto {
  destinationFishGroupId: number;
  id: number;
  operation: TimelineOperationDto;
  sourceFishGroupId: number;
  /**
   *
   * - Format: date-time
   */
  transferDate: string;
  estimatedFishCount?: number;
}

export interface TimelineWeightDto {
  status: TimelineWeightStatus;
  /**
   *
   * The day of that estimate.
   * - Format: date
   */
  day?: string;
  /**
   *
   * Living weight in grams, from the latest licensed daily estimate.
   */
  livingWeight?: number;
}

/**
 *
 * available: a licensed estimate exists. notLicensed: no day of the period is covered by a biomass licence (for a group: no licensed estimate, and part of its time here is unlicensed). noData: licensed, but no estimate.
 */

export enum TimelineWeightStatus {
  available = "available",
  notLicensed = "notLicensed",
  noData = "noData",
}

export interface UnacknowledgeAlert {
  alertCode: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationId: number;
}

export interface UnassignFishGroupsFromCycleResponseDto {
  stockingCycleId: number;
  /**
   *
   * Groups taken out of the stocking. Each gets a metadata_updated event; previousStockingCycleId is the stocking they left.
   */
  unassigned: AssignedFishGroupDto[];
  /**
   *
   * Groups in the cascade that were in no stocking already.
   */
  unchangedFishGroupIds: number[];
}

export interface UnreadableValueDto {
  /**
   *
   * Whether a save cannot write the field, because a stored value above it, or its whole JSON column, is not an object.
   */
  blocked: boolean;
  /**
   *
   * The schema field key the value is stored at, or a SCADA entry part under it such as `extra_config.scada_items[0].item_id`.
   */
  key: string;
  /**
   *
   * Its JSON type, e.g. number or list.
   */
  type: string;
  /**
   *
   * JSON text of the stored value; null for a client admin, who gets the type only.
   */
  value?: string;
}

export interface UnsupportedProviderDto {
  cageIds: number[];
  providerName: string;
}

export interface UpdateBioscope {
  isTestBioscope: boolean;
  description?: string;
}

export interface UpdateCageActiveFishGroupRequest {
  /**
   *
   * The group the correction was written for: the cage's active group when the form was opened. Refused with 409 when another group occupies the cage now, so one group's name or count never lands on the next.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId: number;
  /**
   *
   * Why the correction is being made. Required: a changelog without the reason only records that someone touched something. Persisted as the event notes.
   */
  reason: string;
  /**
   *
   * Corrected initial population size, or null to clear it. Informational only: correcting it does not alter the recorded counts of descendant groups.
   * - minimum: 1
   */
  initialPopulationSize?: number;
  /**
   *
   * New name. Cannot be blank when provided.
   */
  name?: string;
}

export interface UpdateCageDto {
  /**
   *
   * - minLength: 1
   */
  name: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  cageTypeId?: number;
  externalId?: string;
  externalName?: string;
  /**
   *
   * Species in this pen. Omit to inherit the location default; a location may hold several species.
   * - minimum: 1
   * - max: 2147483647
   * @example
   *   2
   */
  fishTypeId?: number;
}

export interface UpdateCageResponse {
  id: number;
}

export interface UpdateClientDto {
  archived?: boolean;
  /**
   *
   * - minLength: 1
   */
  name?: string;
}

export interface UpdateClientLicenseInput {
  numLicenses: number;
}

export interface UpdateFeedingCageConfigDto {
  /**
   *
   * Measurement days this pen needs before its estimates count as reliable. Null clears the override.
   * - minimum: 1
   * - max: 120
   * @example
   *   21
   */
  bioscopeReadyDays?: number;
  /**
   *
   * bFCR interval band: unmarked up to (%). Null clears the override so the pen inherits the site value.
   * @example
   *   25
   */
  confIntervalGoodPct?: number;
  /**
   *
   * bFCR interval band: light mark up to (%). Null clears the override so the pen inherits the site value.
   * @example
   *   40
   */
  confIntervalWarnPct?: number;
  /**
   *
   * Pellet fallthrough alert threshold (%). Null clears the override so the pen inherits the site value.
   * @example
   *   10
   */
  fallthroughAlertPct?: number;
  /**
   *
   * Depth (m) at or below which pellets count as fallthrough. Genuinely per pen: cage depth and camera rigging vary within a site. Null clears the override so the pen inherits the site value.
   * @example
   *   20
   */
  fallthroughDepthThresholdM?: number;
  /**
   *
   * Pellet fallthrough caution threshold (%). Null clears the override so the pen inherits the site value.
   * @example
   *   8
   */
  fallthroughWarnPct?: number;
  /**
   *
   * FCR bio target for this pen. Null clears the override. Null clears the override so the pen inherits the site value.
   * @example
   *   1.05
   */
  fcrTarget?: number;
  /**
   *
   * FCR caution margin (%) above target. Null clears the override so the pen inherits the site value.
   * @example
   *   5
   */
  fcrWarnPct?: number;
  /**
   *
   * RGI target for this pen. Null clears the override so the pen inherits the site value.
   * @example
   *   100
   */
  rgiTarget?: number;
  /**
   *
   * RGI caution margin (%) below target. Null clears the override so the pen inherits the site value.
   * @example
   *   10
   */
  rgiWarnPct?: number;
  /**
   *
   * Upper bound of the healthy SFR range (%). Null clears the override so the pen inherits the site value.
   * @example
   *   2
   */
  sfrHealthyMaxPct?: number;
  /**
   *
   * Lower bound of the healthy SFR range (%). Null clears the override so the pen inherits the site value.
   * @example
   *   1
   */
  sfrHealthyMinPct?: number;
  /**
   *
   * SFR (%) above which overfeeding is likely. Null clears the override so the pen inherits the site value.
   * @example
   *   3
   */
  sfrOverfeedPct?: number;
}

export interface UpdateFeedingDashboardConfigDto {
  /**
   *
   * Bioscope measurement days required before estimates are reliable.
   * - minimum: 1
   * - max: 120
   * @example
   *   21
   */
  bioscopeReadyDays?: number;
  /**
   *
   * bFCR interval band: unmarked up to (%).
   * @example
   *   25
   */
  confIntervalGoodPct?: number;
  /**
   *
   * bFCR interval band: light mark up to (%).
   * @example
   *   40
   */
  confIntervalWarnPct?: number;
  /**
   *
   * Fallthrough red threshold (%).
   * @example
   *   10
   */
  fallthroughAlertPct?: number;
  /**
   *
   * Fallthrough camera depth threshold in metres.
   * - minimum: 1
   * @example
   *   10
   */
  fallthroughDepthThresholdM?: number;
  /**
   *
   * Fallthrough yellow threshold (%).
   * @example
   *   8
   */
  fallthroughWarnPct?: number;
  /**
   *
   * FCR bio target.
   * - minimum: 1
   * @example
   *   1.12
   */
  fcrTarget?: number;
  /**
   *
   * FCR caution margin (%) above target.
   * @example
   *   5
   */
  fcrWarnPct?: number;
  /**
   *
   * Feed vs plan green band (%).
   * @example
   *   5
   */
  feedVsPlanGoodPct?: number;
  /**
   *
   * Feed vs plan yellow band (%).
   * @example
   *   15
   */
  feedVsPlanWarnPct?: number;
  /**
   *
   * Production-planning system name for labels (IPS req 28). Empty or null clears it back to the generic wording.
   * - maxLength: 40
   * @example
   *   Mercatus
   */
  pmsSystemName?: string;
  /**
   *
   * RGI target.
   * - minimum: 1
   * @example
   *   100
   */
  rgiTarget?: number;
  /**
   *
   * RGI caution margin (%) below target.
   * @example
   *   10
   */
  rgiWarnPct?: number;
  /**
   *
   * Healthy SFR range upper bound (%).
   * @example
   *   2
   */
  sfrHealthyMaxPct?: number;
  /**
   *
   * Healthy SFR range lower bound (%).
   * @example
   *   1
   */
  sfrHealthyMinPct?: number;
  /**
   *
   * SFR (%) above which overfeeding is likely.
   * @example
   *   3
   */
  sfrOverfeedPct?: number;
  /**
   *
   * Period length (days) above which the series buckets weekly.
   * - minimum: 7
   * - max: 365
   * @example
   *   31
   */
  weeklyResolutionDays?: number;
  /**
   *
   * Weight deviation green band (%).
   * @example
   *   5
   */
  weightDevGoodPct?: number;
  /**
   *
   * Weight deviation yellow band (%).
   * @example
   *   10
   */
  weightDevWarnPct?: number;
}

export interface UpdateFishGroupMetadataRequest {
  /**
   *
   * Why the correction is being made. Required: a changelog without the reason only records that someone touched something. Persisted as the event notes.
   */
  reason: string;
  /**
   *
   * Corrected initial population size, or null to clear it. Informational only: correcting it does not alter the recorded counts of descendant groups.
   * - minimum: 1
   */
  initialPopulationSize?: number;
  /**
   *
   * New name. Cannot be blank when provided.
   */
  name?: string;
  /**
   *
   * New notes, or null to clear them.
   */
  notes?: string;
}

export interface UpdateLocation {
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  licetypeid: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  locationtypeid: number;
  name: string;
  timezone: string;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  aquacultureSiteId?: number;
  /**
   *
   * - minimum: 1
   * - max: 2147483647
   */
  fishtypeid?: number;
  /**
   *
   * - minimum: -90
   * - max: 90
   */
  latitude?: number;
  /**
   *
   * - minimum: -180
   * - max: 180
   */
  longitude?: number;
}

export interface UpdateStockingCycleRequest {
  /**
   *
   * Cannot be blank or null when provided.
   * - maxLength: 255
   */
  name?: string;
  /**
   *
   * Notes, or null to clear.
   */
  notes?: string;
  /**
   *
   * A date (YYYY-MM-DD), or null to clear it.
   * - Format: date
   * - pattern: /^\d{4}-\d{2}-\d{2}$/
   */
  plannedStartDate?: string;
}

export interface UpdateUserProfileDto {
  defaultLocationDashboard?: DashboardView;
  /**
   *
   * Omit to leave the theme unchanged; null clears it so the portal follows the OS.
   */
  theme?: "light" | "dark";
}

export interface UpdateVideoStreamSettingsInput {
  /**
   *
   * Daily limit in seconds (min 10 min, max 12 hours = 43200)
   * - minimum: 600
   * - max: 43200
   */
  dailyLimitSeconds?: number;
  /**
   *
   * Default stream quality
   */
  defaultQuality?: "HD" | "STANDARD";
  /**
   *
   * Cutoff time: max continuous stream duration in seconds (min 5 min, max 12 h)
   * - minimum: 300
   * - max: 43200
   */
  maxContinuousDurationSeconds?: number;
}

export interface UserLicenseRecord {
  clientId: number;
  clientLicenseId: number;
  clientUserId: number;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface UserLicenseWithClientUser {
  clientId: number;
  clientLicenseId: number;
  clientUserId: number;
  clientUsers: ClientUserRecord;
  /**
   *
   * - Format: date-time
   */
  createdAt: string;
  id: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
}

export interface UserProfileDto {
  defaultLocationDashboard: DashboardView;
  /**
   *
   * Colour theme the user chose. Null when they never chose one: follow the OS.
   */
  theme?: "light" | "dark";
}

export interface Version {
  id: number;
  /**
   *
   * - Format: date-time
   */
  updatedAt: string;
  version: string;
}

export interface VideoStreamSettingsDto {
  /**
   *
   * Daily limit in seconds (min 10 min, max 12 hours = 43200)
   * - minimum: 600
   * - max: 43200
   */
  dailyLimitSeconds: number;
  /**
   *
   * Default stream quality
   */
  defaultQuality: "HD" | "STANDARD";
  /**
   *
   * Cutoff time: max continuous stream duration in seconds (min 5 min, max 12 h)
   * - minimum: 300
   * - max: 43200
   */
  maxContinuousDurationSeconds: number;
}

export interface WeeklyLiceCount {
  /**
   *
   * Fish counted over the week.
   * @example
   *   1480
   */
  count: number;
  /**
   *
   * Adult female lice per fish.
   * @example
   *   0.12
   */
  femaleAvg: number;
  /**
   *
   * Adult female lice per fish under the pre-cut-over model.
   * @example
   *   0.1
   */
  femaleLegacyAvg: number;
  /**
   *
   * Mobile-stage lice per fish.
   * @example
   *   0.31
   */
  movingStageAvg: number;
  /**
   *
   * Mobile-stage lice per fish under the pre-cut-over model.
   * @example
   *   0.28
   */
  movingStageLegacyAvg: number;
  /**
   *
   * ISO week number.
   * @example
   *   22
   */
  weekNumber: number;
  /**
   *
   * ISO week year.
   * @example
   *   2026
   */
  year: number;
  /**
   *
   * Caligus elongatus per fish. Omitted for Chilean-lice locations.
   * @example
   *   0.04
   */
  caligusElongatusAvg?: number;
  /**
   *
   * Caligus elongatus per fish under the pre-cut-over model.
   * @example
   *   0.03
   */
  caligusElongatusLegacyAvg?: number;
}

export interface WeeklyLiceCountResponseDto {
  /**
   *
   * Which implementation actually answered, after the server applied its own rules — a fish group always resolves to `core`, whatever was asked for, and a `compare` whose `core` side failed reports `sql`, because that is whose numbers were served. Always present, so a flag-driven rollout can be read off the response instead of inferred.
   */
  source: "sql" | "core" | "compare";
  weeks: WeeklyLiceCount[];
  /**
   *
   * Only for `source=compare`: how the two implementations differed.
   */
  parity?: LiceParityDto;
}

export interface WeightDistributionBucketResponseDto {
  count?: number;
  from?: number;
  percentage?: number;
  to?: number;
}

export interface WeightDistributionData {
  data: DistributionResultData[];
  day: string;
  daypartTag: string;
  histograms: WeightDistributionHistogram[];
  weightUnitTag: string;
}

export interface WeightDistributionHistogram {
  bucket: Bucket;
  cnt: number;
  cntPct: number;
  dailyDistributionTypeTag: string;
}

export interface WeightOverviewDto {
  /**
   *
   * Acknowledged status list
   */
  ackedStatusList: array[];
  /**
   *
   * Date of weight measurement
   */
  day: string;
  /**
   *
   * Growth rate
   */
  growth: number;
  /**
   *
   * Living weight in grams
   */
  livingWeight: number;
  /**
   *
   * Measurement status level
   */
  measStatusLevel: number;
  /**
   *
   * Measurement status list
   */
  measStatusList: array[];
}

export interface WelfareController_allImagesQueryParams {
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  numberOfImages?: string;
  /**
   *
   * Day-part tag; only the first one is used. A single `tags=day` arrives as a string.
   */
  tags?: string[];
  type?: string;
}

export interface WelfareController_getFullWelfareQueryParams {
  daypartTag: string;
  /**
   *
   * Serve this fish group's data instead of the cage's. The group must have lived in the cage in the path, or the request is rejected. Must be canonical decimal digits — `1e2` is rejected rather than read as 100.
   * - minimum: 1
   * - max: 2147483647
   */
  fishGroupId?: number;
  /**
   *
   * The first day picked, inclusive: a bare `YYYY-MM-DD` or the day's midnight at the site.
   * - Format: date-time
   */
  from?: string;
  /**
   *
   * The last day picked, inclusive: a bare `YYYY-MM-DD` or the day's midnight at the site.
   * - Format: date-time
   */
  to?: string;
}

export interface WelfareOverviewDto {
  /**
   *
   * Date of welfare measurement
   */
  day: string;
  /**
   *
   * Wound rate percentage
   */
  woundRate: number;
  /**
   *
   * Wound slope (weekly trend)
   */
  woundSlope: number;
  /**
   *
   * Downgrade rate percentage
   */
  downgradeRate?: number;
  /**
   *
   * Downgrade slope (weekly trend)
   */
  downgradeSlope?: number;
}

export interface WoundsDataResponseDto {
  development: DailyWoundsResponseDto[];
  numMeasurements: number;
  acute?: number;
  healing?: number;
}

export interface Client {
  id: number;
  name: string;
}
